export default {
  en: {
    'Номер добавлен. Для SMS, WhatsApp и Gateway нужно согласие или аттестация — запишите его.': 'Number added. SMS, WhatsApp and Gateway need consent or an attestation — record it.',
    'Убрали лишние символы: {fix}. Проверьте номер и нажмите «Добавить».': 'Extra characters removed: {fix}. Check the number and press “Add”.',
    '{message}. Может быть, {suggest}?': '{message}. Maybe {suggest}?',
    'Отозвать адрес {hint}? Шаги каналов на него перестанут уходить; подавления не меняются.': 'Revoke address {hint}? Channel steps will stop going to it; suppressions do not change.',
    'Каналы': 'Channels',
    'Номер': 'Number',
    'Ссылка для Telegram': 'Telegram link',
    'Телефон в формате E.164': 'Phone in E.164 format',
    'Добавить': 'Add',
    'Подставить': 'Insert',
    'Загружаю…': 'Loading…',
    'Адресов в каналах нет. Телефон добавляется здесь или по API; Telegram, push и Web Push — только привязкой самим человеком.': 'No addresses on channels. A phone is added here or via API; Telegram, push and Web Push are linked only by the person themselves.',
    'проверен {how}': 'verified {how}',
    'не проверен': 'not checked',
    'Согласие': 'Consent',
    'Отозвать {hint}': 'Revoke {hint}',
    'Сервисные': 'Service',
    'серв.: {status}': 'svc: {status}',
    'Маркетинг': 'Marketing',
    'марк.: {status}': 'mkt: {status}',
    'подавлен': 'suppressed',
    'Недоступен в:': 'Unavailable in:',
    'Подавления каналов:': 'Channel suppressions:',
    'всё': 'all',
    'маркетинг': 'marketing',
    'Подавление сильнее согласия.': 'Suppression overrides consent.',
    'Журнал согласий по каналам · {n}': 'Consent log by channel · {n}',
    'сервисные': 'service',
    'записано {time}': 'recorded {time}',
    'кто записал: {name}': 'recorded by: {name}',
    'доказательство не приложено': 'no proof attached',
    'Последние уведомления': 'Recent notifications',
    'код': 'code',
    'сервисное': 'service',
    'Записано в журнал согласий': 'Recorded in the consent log',
    'Согласие · {hint}': 'Consent · {hint}',
    'Отмена': 'Cancel',
    'Записать': 'Save',
    'Канал': 'Channel',
    'Цель': 'Goal',
    'Отзыв': 'Withdrawal',
    'Источник (обязательно)': 'Source (required)',
    'Откуда согласие: checkout_form, phone_call, support…': 'Where the consent came from: checkout_form, phone_call, support…',
    'Доказательство': 'Evidence',
    'Обязательно для согласия: как и когда получено': 'Required for consent: how and when it was obtained',
    'Необязательно': 'Optional',
    'Галочка «Получать SMS о заказе» при оформлении заказа A-1042': 'Checkbox “Receive SMS about the order” at checkout for order A-1042',
    'Подавление сильнее согласия: новая запись «согласие» его не снимает.': 'Suppression overrides consent: a new “consent” record does not lift it.',
    'Политика каскада': 'Cascade policy',
    'Только «сообщение»: коды отправляет Verify API.': 'Only “message”: codes are sent by the Verify API.',
    'Политики': 'Policies',
    '— выберите —': '— choose —',
    ' (встроенная)': ' (built-in)',
    '{key} (не найдена)': '{key} (not found)',
    'Версия политики': 'Policy version',
    'Закрепляется в версии сценария: изменение политики потом не меняет одобренный сценарий': 'Pinned in the journey version: a later policy change does not alter the approved journey',
    'последняя (сейчас v{version})': 'latest (now v{version})',
    'Худший случай:': 'Worst case:',
    'на участника': 'per participant',
    'Обычно дешевле — каскад останавливается на успехе.': 'Usually cheaper — the cascade stops on success.',
    'Маркетинговому уведомлению нужна политика с «если нет сигнала — остановиться»: иначе человек может получить сообщение дважды. Сохранение версии сценария это не пропустит.': 'A marketing notification needs a policy with “if no signal — stop”: otherwise a person may get the message twice. Saving the journey version will not skip this.',
    'Шаблон канала': 'Channel template',
    'Шаблонов нет — создайте в «Каналы → Шаблоны»': 'No templates — create them in Channels → Templates',
    '{key} (не найден)': '{key} (not found)',
    'Версия шаблона': 'Template version',
    '— варианты шаблона; шаг без варианта пропускается': '— template variants; a step without a variant is skipped',
    'Переменные шаблона': 'Template variables',
    'Путь — начинается с «=»: =contact.attributes.first_name; иначе — постоянное значение': 'A path starts with “=”: =contact.attributes.first_name; otherwise it is a fixed value',
    'Источник {name}': 'Source {name}',
    'по умолч.': 'default',
    'Значение по умолчанию {name}': 'Default value for {name}',
    'Поток': 'Stream',
    'Маркетинг: нужно согласие на канал, тихие часы и частотный лимит': 'Marketing: needs channel consent, quiet hours and a frequency cap',
    'Сервисное: без согласия на маркетинг; согласующий подтверждает, что рекламы нет': 'Service: no marketing consent needed; the approver confirms there is no advertising',
    'как у сценария ({kind})': 'as the journey ({kind})',
    'транзакционные': 'transactional',
    'транзакционные (сервисные)': 'transactional (service)',
    'Если все каналы пропущены': 'If all channels are skipped',
    'Нет адреса, согласия, подавление, тихие часы, лимит': 'No address, consent, suppression, quiet hours or cap',
    'идти дальше': 'continue',
    'завершить участие': 'end enrollment',
    'Шаг перемещён на позицию {n}': 'Step moved to position {n}',
    'Шаг {n} поднят. Стрелки вверх и вниз — переместить, пробел — опустить, Esc — отмена.': 'Step {n} picked up. Up and down arrows — move, space — drop, Esc — cancel.',
    'Шаг опущен на позицию {n}': 'Step dropped at position {n}',
    'Позиция {n} из {total}': 'Position {n} of {total}',
    'Перемещение отменено': 'Move cancelled',
    'Вид политики': 'Policy type',
    'Сообщение': 'Message',
    'Код подтверждения': 'Verification code',
    'Успех — только введённый код. Во всех каналах уходит': 'Success is only the entered code. Every channel sends',
    'один и тот же код': 'the same code',
    ', поэтому после дедлайна шага всегда идёт следующий канал; email — только последним (тело письма хранится).': ', so after each step deadline the next channel always follows; email goes last only (the message body is kept).',
    'Что считать успехом': 'What counts as success',
    'Каскад идёт дальше, пока этого сигнала нет к дедлайну шага': 'The cascade moves on until this signal arrives by the step deadline',
    'Принято каналом': 'Accepted by channel',
    'Доставлено (по отчёту оператора)': 'Delivered (per carrier report)',
    'Прочитано': 'Read',
    'Цель — событие вашего сервера': 'Goal — an event from your server',
    'Событие цели': 'Goal event',
    'POST /v1/events с этим именем или POST /v1/notifications/:id/signal': 'POST /v1/events with this name, or POST /v1/notifications/:id/signal',
    'Длина кода': 'Code length',
    'Срок кода, с': 'Code lifetime, s',
    'Попыток ввода': 'Input attempts',
    'Шаги каскада': 'Cascade steps',
    'по порядку; перетащите за ручку или клавиатурой': 'in order; drag the handle or use the keyboard',
    'Цены для': 'Prices for',
    'Страна-образец для цены': 'Sample country for prices',
    'Шаг {n}: {channel}. Переместить': 'Step {n}: {channel}. Move',
    'Дедлайн (последний — необязательно), с': 'Deadline (last one — optional), s',
    'Дедлайн, с': 'Deadline, s',
    'ждать сигнала': 'wait for a signal',
    'Успех шага': 'Step success',
    'как у политики': 'as the policy',
    'сообщает максимум:': 'reports at most:',
    'ждём {time}': 'waiting {time}',
    'цена шага:': 'step price:',
    'нет в прайсе': 'not in the price list',
    ' (ваш аккаунт, ориентировочно)': ' (your account, approximate)',
    ' (бесплатно)': ' (free)',
    'не подключён': 'not connected',
    'Шаг без цены не выполняется: деньги не тратятся вслепую': 'A step without a price does not run: money is not spent blindly',
    'шаг не выполнится': 'the step will not run',
    'Шаг {n} выше': 'Step {n} up',
    'Шаг {n} ниже': 'Step {n} down',
    'Удалить шаг {n}': 'Delete step {n}',
    'Добавить шаг': 'Add step',
    'Параллельно с каскадом': 'In parallel with the cascade',
    'Уходят сразу и не отменяются успехом каскада (например, письмо-копия)': 'Sent right away and not cancelled by the cascade’s success (for example, an email copy)',
    'Потолок цены уведомления, €': 'Notification price cap, €',
    'Шаг дороже остатка пропускается (over_budget)': 'A step costing more than the remainder is skipped (over_budget)',
    'без потолка': 'no cap',
    'Тихие часы получателя': 'Recipient quiet hours',
    'не учитывать (сервисные)': 'ignore (service)',
    'ждать утра': 'wait until morning',
    'пропустить шаг': 'skip step',
    'Страны (через запятую)': 'Countries (comma-separated)',
    'Пусто — разрешённые страны пространства': 'Empty — the workspace’s allowed countries',
    'Если исход шага неизвестен': 'If the step outcome is unknown',
    'остановиться (не дублировать)': 'stop (do not duplicate)',
    'следующий канал': 'next channel',
    ' — только для кодов': ' — codes only',
    'Если к дедлайну нет сигнала': 'If there is no signal by the deadline',
    'остановиться': 'stop',
    'Человек может получить сообщение дважды.': 'The person may get the message twice.',
    'При неизвестном исходе следующий канал получит тот же код — дубль безопасен, потерянный вход хуже.': 'With an unknown outcome the next channel gets the same code — a duplicate is safe, a lost sign-in is worse.',
    'Если первый канал доставил, но не сообщил об этом к дедлайну, следующий канал продублирует сообщение. Для маркетинга в сценариях это запрещено.': 'If the first channel delivered but did not report it by the deadline, the next channel will duplicate the message. Journeys must not do this for marketing.',
    'Худший случай для {country}:': 'Worst case for {country}:',
    '— если каждый шаг дойдёт до поставщика. Обычно дешевле: каскад останавливается на успехе.': '— if every step reaches the provider. Usually cheaper: the cascade stops on success.',
    'Канал не сообщает такой сигнал': 'The channel does not report such a signal',
    'Политика не прошла проверку': 'The policy failed validation',
    'QR-код ссылки привязки': 'QR code of the link',
    'Подключите бота, чтобы создавать ссылки.': 'Connect a bot to create links.',
    'Контакт': 'Contact',
    'Бот': 'Bot',
    'Человек также соглашается на маркетинговые сообщения': 'The person also agrees to marketing messages',
    'Создать ссылку': 'Create link',
    'Одноразовая, действует до {time}. Человек нажимает «Start» — чат привязывается к контакту.': 'One-time, valid until {time}. The person presses “Start” — the chat is linked to the contact.',
    ' (может быть, {suggest}?)': ' (maybe {suggest}?)',
    '{n} симв.': '{n} chars',
    'сегмент': 'segment',
    'сегмента': 'segments',
    'сегментов': 'segments',
    'осталось {n} в последнем': '{n} left in the last one',
    'Unicode из-за: {chars} — сегмент 70 вместо 160 знаков': 'Unicode because of: {chars} — 70 characters per segment instead of 160',
    'тест {v}': 'test {v}',
    'Данные: JSON не разбирается': 'Data: JSON cannot be parsed',
    'Код верный: каскад остановлен, следующие шаги отменены': 'The code is correct: the cascade is stopped, the next steps are cancelled',
    'Статус: {status}': 'Status: {status}',
    'Неверный код, осталось попыток: {n}': 'Wrong code, attempts left: {n}',
    'Неверный код': 'Wrong code',
    'Верификация уже не ждёт кода (подтверждена, истекла или попытки кончились)': 'The verification no longer waits for a code (confirmed, expired or out of attempts)',
    'Тестовый код подтверждения': 'Test verification code',
    'Тестовая отправка': 'Test send',
    'Закрыть': 'Close',
    'Смотреть погружение': 'View the deep dive',
    'Отправляю…': 'Sending…',
    'Отправить код': 'Send code',
    'Отправить': 'Send',
    'сообщение': 'message',
    'Варианты: {list}': 'Variants: {list}',
    'Создайте шаблон в «Каналы → Шаблоны»': 'Create a template in Channels → Templates',
    'Получатель': 'Recipient',
    'Телефон': 'Phone',
    'Мой email': 'My email',
    'Номер в формате E.164': 'Number in E.164 format',
    'С тестовым поставщиком исход решает последняя цифра: 1 — отказ, 2 — неизвестно, 3 — отказ после приёма, 6 — без отчёта, иначе — доставлено': 'With the test provider the last digit decides the outcome: 1 — refusal, 2 — unknown, 3 — refusal after acceptance, 6 — no report, otherwise — delivered',
    'Id контакта': 'Contact ID',
    'Шаги пойдут по адресам контакта: телефон, Telegram, push, web push': 'Steps go to the contact’s addresses: phone, Telegram, push, web push',
    'Только email-шаги дойдут: на ваш адрес {email}. Остальные каналы пропустятся — у вас как участника нет в них адреса.': 'Only email steps will arrive: to your address {email}. Other channels will be skipped — as a member you have no address in them.',
    'Данные шаблона (JSON)': 'Template data (JSON)',
    'Тестовая отправка — настоящая: платные шаги учитываются в расходах. Не больше 10 в час на пространство.': 'This is a real test send: paid steps count toward spend. No more than 10 an hour per workspace.',
    'Уведомление': 'Notification',
    'создано. Худший случай по цене:': 'created. Worst-case price:',
    'Введите код из сообщения': 'Enter the code from the message',
    'Верный код останавливает каскад: шаги, ещё не переданные поставщику, отменяются': 'A correct code stops the cascade: steps not yet handed to the provider are cancelled',
    'Проверить код': 'Check code',
    'Тестовый телефон': 'Test phone',
    'только вне production': 'non-production only',
    'Здесь появятся сообщения, которые получил бы человек от тестового поставщика.': 'Messages a person would receive from the test provider will appear here.',
    'шаблон Meta «{name}»': 'Meta template «{name}»',
    'код:': 'code:',
    'Тестовый поставщик: сообщения никуда не уходят': 'Test provider: messages are not sent anywhere',
    'тестовый': 'test',
    'Проверено от начала до конца': 'Verified end to end',
    'проверено': 'verified',
    'Адаптер написан по официальной документации поставщика, но ещё не проверен на настоящем аккаунте': 'The adapter follows the provider’s official documentation but has not yet been checked on a real account',
    'не проверено на живом аккаунте': 'not verified on a live account',
    '{channel} не сообщает этот сигнал': '{channel} does not report this signal',
    'За 7 дней: факт поставщика, до его прихода — оценка': 'Last 7 days: the provider’s actual figure; until it arrives — an estimate',
    'стоимость': 'cost',
    'Шаг {seq} — неизвестный исход: дальше не шлём, чтобы не продублировать.': 'Step {seq} — unknown outcome: we stop here so nothing is duplicated.',
    'Исход шага {seq} был неизвестен; сотрудник MailOcean сверил его вручную ({result}). Каскад не возобновляется.': 'The outcome of step {seq} was unknown; a MailOcean employee reconciled it manually ({result}). The cascade does not resume.',
    'принято поставщиком': 'accepted by the provider',
    'не принято': 'not accepted',
    'код {code}': 'code {code}',
    'попытка {n}': 'attempt {n}',
    '{n} сегм.': '{n} seg.',
    'через {via}': 'via {via}',
    'параллельно': 'parallel',
    'шаг {seq}': 'step {seq}',
    'успех здесь': 'success here',
    'Факт по данным поставщика': 'Actual per provider data',
    'Оценка до отчёта поставщика': 'Estimate until the provider report',
    'не оплачивается': 'not charged',
    'факт {sum}': 'actual {sum}',
    'оценка {sum}': 'estimate {sum}',
    'ваш аккаунт': 'your account',
    'дедлайн {n}': 'deadline {n}',
    'письмо {id}…': 'email {id}…',
    'Пропущен: {reason}.': 'Skipped: {reason}.',
    'Сверено сотрудником MailOcean вручную: {result}. Время приёма у поставщика неизвестно; каскад не возобновляется.': 'Reconciled manually by a MailOcean employee: {result}. The provider’s acceptance time is unknown; the cascade does not resume.',
    'поставщик принял сообщение': 'the provider accepted the message',
    'поставщик сообщение не принял': 'the provider did not accept the message',
    'Отказ поставщика:': 'Provider refusal:',
    ' — точный отказ, можно идти дальше.': ' — an exact refusal, the cascade can move on.',
    'Неизвестный исход: поставщик мог принять сообщение. Повтора не будет': 'Unknown outcome: the provider may have accepted the message. There will be no retry',
    '; у кода подтверждения следующий канал получает тот же код.': '; the next channel gets the same code for a verification code.',
    ' — дальше не шлём, чтобы не продублировать.': ' — we stop here so nothing is duplicated.',
    'события шага · {n}': 'step events · {n}',
    'Каскад остановлен.': 'The cascade is stopped.',
    'Не отправлено ни в один канал.': 'Not sent on any channel.',
    'Каждый шаг пропущен или получил точный отказ — причины ниже.': 'Every step was skipped or got an exact refusal — the reasons are below.',
    'Срок кода истёк.': 'The code has expired.',
    'Код не ввели вовремя; запечатанная копия кода удалена.': 'The code was not entered in time; the sealed copy of the code has been deleted.',
    'Отменено.': 'Cancelled.',
    'Шаги, ещё не переданные поставщику, отменены; переданные не отзываются.': 'Steps not yet handed to the provider are cancelled; handed-over steps cannot be recalled.',
    'Параллельно с каскадом (не отменяются его успехом)': 'In parallel with the cascade (not cancelled by its success)',
    'события уведомления · {n}': 'notification events · {n}',
    'цены нет': 'no price',
    '{n} с': '{n} s',
    '{n} мин': '{n} min',
    '{n} ч': '{n} h',
    '{n} мс': '{n} ms',
    '{m} мин {s} с': '{m} min {s} s',
    '// Та же политика = та же версия: повтор безопасен': '// Same policy = same version: a retry is safe',
    '// SDK ставит Idempotency-Key сам и повторяет запрос с тем же ключом': '// The SDK sets Idempotency-Key itself and retries with the same key',
    'Все каналы': 'All channels',
    'Подключение': 'Connection',
    'Логи канала': 'Channel log',
    'Неизвестные исходы': 'Unknown outcomes',
    'Тестовый {channel}': 'Test {channel}',
    'Тестовый поставщик подключён: сообщения никуда не уходят': 'Test provider connected: messages are not sent anywhere',
    'Без аккаунта поставщика?': 'No provider account?',
    'Подключите тестовый поставщик (только вне production): исход решает последняя цифра адреса, сообщения видны в «Тестовом телефоне».': 'Connect the test provider (non-production only): the last digit of the address decides the outcome, messages are visible in the “Test phone”.',
    'Подключить тестовый': 'Connect test provider',
    'Аттестация отозвана': 'Attestation revoked',
    'Аттестация записана в журнал': 'Attestation recorded in the log',
    'Аттестация согласий': 'Consent attestation',
    'Сервисные сообщения WhatsApp идут без согласия по каждому адресу только после письменного подтверждения владельца. Без него шаг пропускается с причиной «нет согласия».': 'WhatsApp service messages go out without per-address consent only after the owner’s written confirmation. Without it the step is skipped with the reason “no consent”.',
    'Telegram Gateway требует, чтобы коды получали только те, кто сам их запросил (условия Telegram).': 'Telegram Gateway requires that codes are received only by those who requested them (Telegram terms).',
    'версия {n}': 'version {n}',
    'подтверждено': 'confirmed',
    'версия текста {n}': 'text version {n}',
    'Отозвать': 'Revoke',
    'Подтверждаю': 'I confirm',
    'Подтвердить может только владелец пространства.': 'Only the workspace owner can confirm.',
    'Аттестации нет.': 'There is no attestation.',
    'Платформенный SMS MailOcean': 'MailOcean platform SMS',
    'Подключать ничего не нужно: MailOcean отправляет через своих операторов (Twilio IE1, Messente) и выставляет SMS в счёт с наценкой.': 'Nothing to connect: MailOcean sends through its own carriers (Twilio IE1, Messente) and bills SMS with a markup.',
    'Сейчас SMS идут через тестовый поставщик «{name}». Он играет роль платформенного SMS: цены — с наценкой MailOcean, в «Маяке» оплата видна как «MailOcean», настоящие SMS не уходят.': 'SMS currently go through the test provider “{name}”. It plays the role of platform SMS: prices include the MailOcean markup, in Lighthouse the payment shows as “MailOcean”, real SMS are not sent.',
    'Сейчас SMS идут через ваш аккаунт «{name}».': 'SMS currently go through your account “{name}”.',
    'MailOcean ещё не подключил платформенные SMS — подключите свой аккаунт ниже или тестовый поставщик.': 'MailOcean has not enabled platform SMS yet — connect your own account below or a test provider.',
    'Имя отправителя по умолчанию — «MailOcean». Своё имя (до 11 символов) регистрируется у операторов: напишите в поддержку, указав имя и страны.': 'The default sender name is “MailOcean”. Your own name (up to 11 characters) is registered with carriers: write to support with the name and countries.',
    'Цены по странам': 'Prices by country',
    'за сообщение, SMS — за сегмент': 'per message; SMS — per segment',
    'Страна': 'Country',
    'Разрешена': 'Allowed',
    'Цена': 'Price',
    'Действует с': 'Valid from',
    'Разрешить {country}': 'Allow {country}',
    'да': 'yes',
    'нет': 'no',
    'Без цены шаг не выполняется': 'Without a price the step does not run',
    'нет цены': 'no price',
    'общая': 'shared',
    'Номера стран вне разрешённых пропускаются с причиной «страна не разрешена».': 'Numbers from countries outside the allowed list are skipped with the reason “country not allowed”.',
    'Свой Twilio или Messente': 'Your own Twilio or Messente',
    'Если у вас уже есть договор с оператором: SMS пойдут через ваш аккаунт, оплата — напрямую поставщику, MailOcean их не выставляет в счёт.': 'If you already have a contract with a carrier: SMS go through your account, payment goes directly to the provider, and MailOcean does not bill them.',
    'Аккаунты WhatsApp Business': 'WhatsApp Business accounts',
    'Подключить вручную': 'Connect manually',
    'Как подключить': 'How to connect',
    'В Meta Business Manager создайте приложение типа': 'In Meta Business Manager create an app of type',
    'и добавьте продукт WhatsApp.': 'and add the WhatsApp product.',
    'Создайте системного пользователя (Admin), назначьте ему приложение и WABA, выпустите постоянный токен с правами': 'Create a system user (Admin), assign it the app and the WABA, issue a permanent token with the permissions',
    'и': 'and',
    'Скопируйте Phone number ID, WABA ID и App Secret (App settings → Basic) и вставьте в форму.': 'Copy the Phone number ID, WABA ID and App Secret (App settings → Basic) and paste them into the form.',
    'После подключения MailOcean покажет Callback URL и Verify token: вставьте их в WhatsApp → Configuration и подпишитесь на поле': 'After connecting, MailOcean shows the Callback URL and Verify token: paste them into WhatsApp → Configuration and subscribe to the field',
    'Meta выставляет счёт вам напрямую — цены в каскаде ориентировочные (по категории шаблона). Вне окна 24 ч WhatsApp пропускает только одобренные шаблоны.': 'Meta bills you directly — prices in the cascade are approximate (by template category). Outside the 24 h window WhatsApp passes only approved templates.',
    'Шаблонов синхронизировано: {n}': 'Templates synced: {n}',
    'Шаблоны Meta · {n}': 'Meta templates · {n}',
    'Синхронизировать': 'Sync',
    'Шаблонов нет или ещё не синхронизированы.': 'No templates, or they are not synced yet.',
    'Боты': 'Bots',
    'Добавить бота': 'Add bot',
    'Бот уведомлений': 'Notifications bot',
    'Ссылка привязки для контакта': 'Link for a contact',
    'Как получить токен у @BotFather': 'How to get a token from @BotFather',
    'Откройте в Telegram': 'Open Telegram and find',
    'и отправьте': 'and send',
    'Задайте имя и username, оканчивающийся на': 'Set a name and a username ending in',
    'BotFather пришлёт токен вида': 'BotFather will send a token like',
    'Токен никому не пересылайте.': 'Never forward the token to anyone.',
    'Вставьте токен в «Добавить бота». MailOcean проверит его (': 'Paste the token into “Add bot”. MailOcean will check it (',
    ') и сам поставит вебхук.': ') and set the webhook itself.',
    'Бот пишет только тем, кто сам нажал «Start» по вашей ссылке. Telegram не сообщает боту «доставлено» и «прочитано» — в каскаде у этого канала только «принято». Если человек заблокирует бота, адрес отзывается и следующий шаг каскада пойдёт дальше.': 'The bot only writes to people who pressed “Start” via your link. Telegram does not tell the bot “delivered” or “read” — in the cascade this channel only has “accepted”. If a person blocks the bot, the address is revoked and the cascade moves on to the next step.',
    'Оплачивается вашим аккаунтом Telegram.': 'Billed to your Telegram account.',
    'Telegram Gateway списывает плату за каждый код с баланса вашего аккаунта Gateway; MailOcean её не выставляет в счёт. Канал только для кодов подтверждения.': 'Telegram Gateway charges each code from the balance of your Gateway account; MailOcean does not bill it. This channel is for verification codes only.',
    'Токен Gateway': 'Gateway token',
    'Вставить токен': 'Paste token',
    'Gateway сам проверяет, есть ли у номера Telegram: если нет — шаг получает точный отказ, и каскад сразу идёт к SMS. Если код использован раньше, MailOcean отзывает сообщение Gateway (деньги за недоставленные коды Telegram возвращает сам).': 'Gateway itself checks whether the number has Telegram: if not, the step gets an exact refusal and the cascade goes straight to SMS. If the code was used earlier, MailOcean recalls the Gateway message (Telegram itself refunds the money for undelivered codes).',
    'Приложения': 'Apps',
    'квитанции включены: доставка и нажатия видны': 'receipts on: delivery and clicks are visible',
    'без квитанций: только «принято»': 'no receipts: only “accepted”',
    'Android-приложение': 'Android app',
    'iOS-приложение': 'iOS app',
    'Регистрация устройства': 'Device registration',
    'Ваш сервер передаёт токен устройства после входа пользователя (или приложение — через одноразовый identify-токен). Токены хранятся запечатанными.': 'Your server passes the device token after the user signs in (or the app does it through a one-time identify token). Tokens are stored sealed.',
    'Мой сайт': 'My site',
    'Приложение Web Push создано: ключи VAPID готовы': 'Web Push app created: VAPID keys are ready',
    'Ещё один сайт': 'Another site',
    'Web Push не подключён': 'Web Push is not connected',
    'Укажите адрес сайта — MailOcean создаст ключи VAPID и покажет три шага установки.': 'Enter the site address — MailOcean will create VAPID keys and show three setup steps.',
    'Подключить сайт': 'Connect a site',
    'Название': 'Name',
    'Origin сайта (через запятую)': 'Site origin (comma-separated)',
    'https://shop.example.lv — подписки принимаются только с этих адресов. Вне production можно http://localhost:порт': 'https://shop.example.lv — subscriptions are accepted only from these addresses. Outside production http://localhost:port is allowed',
    'Создать ключи': 'Create keys',
    'Поддержка браузеров': 'Browser support',
    'Chrome, Edge, Firefox, Opera — на компьютере и Android. Safari на macOS — с версии 16. На iPhone и iPad (iOS 16.4+) уведомления работают только у сайта, добавленного на экран «Домой» как веб-приложение (нужен манифест), и только после нажатия пользователя.': 'Chrome, Edge, Firefox, Opera — on desktop and Android. Safari on macOS — from version 16. On iPhone and iPad (iOS 16.4+) notifications work only for a site added to the Home Screen as a web app (a manifest is required), and only after a user tap.',
    'Доставку видно по квитанции нашего service worker («доставлено»), нажатие — «прочитано». Подписка, которую браузер отозвал (404/410), помечается недействительной, и каскад идёт к следующему каналу.': 'Delivery is visible via a receipt from our service worker (“delivered”), a tap — “read”. A subscription the browser revoked (404/410) is marked invalid, and the cascade moves on to the next channel.',
    'Адреса сайта сохранены': 'Site addresses saved',
    'Этот браузер не поддерживает Web Push.': 'This browser does not support Web Push.',
    'Разрешение есть. Подпишитесь на своём сайте через MailOceanPush.subscribe(), затем отправьте тест на контакт.': 'Permission granted. Subscribe on your site via MailOceanPush.subscribe(), then send a test to the contact.',
    'Разрешение на уведомления не дано.': 'Notification permission was not granted.',
    'Web Push проверен от начала до конца против push-сервиса': 'Web Push verified end to end against the push service',
    'Сайты: {origins} · ключи созданы {ago}': 'Sites: {origins} · keys created {ago}',
    'Подключите SDK': 'Include the SDK',
    'на каждой странице (с проверкой целостности SRI):': 'on every page (with SRI integrity check):',
    'Положите service worker': 'Put the service worker',
    'в корень сайта как': 'at the site root as',
    'Скачать mailocean-sw.js': 'Download mailocean-sw.js',
    'Подпишите посетителя по нажатию': 'Subscribe the visitor on a tap',
    '(браузеры требуют действие пользователя):': '(browsers require a user action):',
    'одноразовый токен с вашего сервера': 'a one-time token from your server',
    'так подписка привязывается к контакту.': 'this is how the subscription is linked to the contact.',
    'Публичный ключ VAPID и SRI': 'VAPID public key and SRI',
    'Origin сайта': 'Site origin',
    'Сохранить адреса': 'Save addresses',
    'Проверить этот браузер': 'Check this browser',
    'Кабинет открыт с одного из адресов сайта.': 'The dashboard is open from one of the site’s addresses.',
    'Неизвестный исход': 'Unknown outcome',
    '— поставщик мог принять сообщение (таймаут после отправки, обрыв, двусмысленный ответ). MailOcean такие шаги': '— the provider may have accepted the message (timeout after sending, dropped connection, ambiguous reply). MailOcean such steps',
    'никогда не повторяет': 'never retries',
    'и дальше по каскаду не идёт (кроме кодов подтверждения — там следующий канал получает тот же код). Сверку по доказательствам поставщика делает поддержка MailOcean.': 'and the cascade does not go further (except for verification codes — there the next channel gets the same code). Reconciliation against the provider’s evidence is done by MailOcean support.',
    'принят': 'accepted',
    'доставлен': 'delivered',
    'прочитан': 'read',
    'отказ': 'failed',
    'пропуск': 'skipped',
    'неизвестно': 'unknown',
    'отменён': 'cancelled',
    'все': 'all',
    'Неизвестных исходов нет': 'No unknown outcomes',
    'Шагов пока нет': 'No steps yet',
    'Когда': 'When',
    'Адрес': 'Address',
    'Состояние': 'Status',
    'Стоимость': 'Cost',
    'шаг параллельный': 'parallel step',
    'шаг {n}': 'step {n}',
    'оценка': 'estimate',
    'Показать ещё': 'Show more',
    'Одно уведомление — каскад по каналам: push, Telegram, SMS, WhatsApp, письмо. Дальше по каскаду идём только при точном отказе или по дедлайну — неизвестный исход не дублируем.': 'One notification — a cascade across channels: push, Telegram, SMS, WhatsApp, email. The cascade moves on only on an exact refusal or a deadline — an unknown outcome is never duplicated.',
    'Шагов с неизвестным исходом: {n}.': 'Steps with an unknown outcome: {n}.',
    'Поставщик мог их принять, поэтому MailOcean их не повторяет и дальше по каскаду не идёт; сверку делает поддержка MailOcean.': 'The provider may have accepted them, so MailOcean does not retry them and the cascade does not move on; reconciliation is done by MailOcean support.',
    'Смотреть остановленные': 'View stopped ones',
    'ваши домены': 'your domains',
    ' · аккаунтов: {n}': ' · accounts: {n}',
    'платформенный SMS ещё не включён MailOcean': 'platform SMS is not enabled by MailOcean yet',
    'аккаунта нет': 'no account',
    'подключён': 'connected',
    'отключён вами': 'disabled by you',
    'пауза MailOcean': 'paused by MailOcean',
    'адресов: {n}': 'addresses: {n}',
    'за 7 дней · отказов {failed} · неизвестных {unknown} · пропусков {skipped}': 'last 7 days · failed {failed} · unknown {unknown} · skipped {skipped}',
    'Настроить': 'Configure',
    'Подключить': 'Connect',
    'Честные сигналы': 'Honest signals',
    'поставщик взял сообщение — ещё не доставка': 'the provider took the message — not delivery yet',
    'Доставлено': 'Delivered',
    'только по отчёту оператора (SMS, WhatsApp) или квитанции нашего SDK (Web Push, push с квитанциями)': 'only per carrier report (SMS, WhatsApp) or our SDK receipt (Web Push, push with receipts)',
    'статус read (WhatsApp, Gateway) или нажатие по уведомлению': 'read status (WhatsApp, Gateway) or a click on the notification',
    'ваш сервер сообщил: код введён, заказ открыт': 'your server reported: code entered, order opened',
    'Telegram-бот сообщает только «принято»: доставку и прочтение Bot API не отдаёт. Push без квитанций приложения — тоже только «принято».': 'The Telegram bot reports only “accepted”: the Bot API does not return delivery or read status. Push without app receipts is also only “accepted”.',
    'Разделы каналов': 'Channel sections',
    'без страны': 'no country',
    'Расходы на каналы': 'Channel costs',
    'Стоимость по данным поставщика; пока отчёта нет — оценка. Платные шаги вашим аккаунтом поставщика (свой Twilio, WhatsApp, Gateway) MailOcean не выставляет в счёт.': 'Costs per provider data; until the report arrives — an estimate. Paid steps through your own provider account (own Twilio, WhatsApp, Gateway) are not billed by MailOcean.',
    'За {n} дней': 'Last {n} days',
    'все платные шаги': 'all paid steps',
    'Оплачено MailOcean': 'Paid via MailOcean',
    'попадёт в счёт': 'goes on your invoice',
    'Вашим аккаунтом': 'Your account',
    'оценка, платите поставщику': 'estimate, paid to the provider',
    'Сегодня из лимита': 'Today against the limit',
    'Израсходовано {n} % дневного лимита': '{n}% of the daily limit used',
    'лимит задаёт MailOcean': 'the limit is set by MailOcean',
    ' (ваш личный)': ' (your own)',
    'По дням': 'By day',
    'По каналам': 'By channel',
    'По странам': 'By country',
    'Период': 'Period',
    '7 дней': '7 days',
    '14 дней': '14 days',
    '30 дней': '30 days',
    '90 дней': '90 days',
    'оплачено MailOcean': 'paid via MailOcean',
    'вашим аккаунтом (оценка)': 'via your account (estimate)',
    'За период платных шагов не было.': 'There were no paid steps in this period.',
    '{label}: принято {accepted}, доставлено {delivered}, единиц {units}': '{label}: accepted {accepted}, delivered {delivered}, units {units}',
    'День': 'Day',
    'Принято': 'Accepted',
    'Единиц': 'Units',
    'В счёт MailOcean': 'Billed by MailOcean',
    'Сохранено': 'Saved',
    'Аттестация записана': 'Attestation recorded',
    'Настройки каналов': 'Channel settings',
    'Правила пространства: где можно отправлять, когда молчать, какие каналы выключены.': 'Workspace rules: where you can send, when to stay quiet, which channels are off.',
    'MailOcean приостановил каналы:': 'MailOcean has paused channels:',
    'Сообщения этих каналов ждут в очереди.': 'Messages on these channels wait in the queue.',
    'Разрешённые страны': 'Allowed countries',
    'Номера других стран пропускаются (причина «страна не разрешена»). Сейчас доступны только ЕС и ЕЭЗ.': 'Numbers from other countries are skipped (reason “country not allowed”). Currently only the EU and EEA are available.',
    'Страны на паузе из-за подозрения на накрутку SMS (pumping):': 'Countries paused over suspected SMS pumping:',
    'Снять паузу может поддержка MailOcean.': 'MailOcean support can lift the pause.',
    'Канал включён': 'Channel enabled',
    'Канал выключен: его шаги будут ждать': 'Channel disabled: its steps will wait',
    'выключен': 'off',
    'Выключенный канал — удержание: строки ждут в очереди и уйдут после включения (кроме тех, чей шаг каскада закроет дедлайн).': 'A disabled channel holds its rows: they wait in the queue and go out once it is on (except those whose cascade step hits its deadline).',
    'Тихие часы маркетинга': 'Marketing quiet hours',
    'По поясу контакта. Сервисные сообщения и коды идут всегда. По умолчанию {start}–{end}.': 'In the contact’s time zone. Service messages and codes always go out. Default {start}–{end}.',
    'Начало': 'Start',
    'Конец': 'End',
    'Сохранить': 'Save',
    'Возвращены часы по умолчанию': 'Default hours restored',
    'По умолчанию': 'Default',
    'Аттестации': 'Attestations',
    'Подтверждает только владелец пространства; текст и версия пишутся в журнал.': 'Only the workspace owner confirms; the text and version are written to the log.',
    'Дневной лимит расходов': 'Daily spend limit',
    'в сутки · сегодня': 'per day · today',
    'Когда лимит исчерпан, платные шаги пропускаются (причина «дневной лимит»), бесплатные каналы работают. Изменить лимит может MailOcean — напишите в поддержку.': 'When the limit is reached, paid steps are skipped (reason “daily limit”); free channels keep working. Only MailOcean can change the limit — contact support.',
    'код {n} цифр, {ttl}': 'code {n} digits, {ttl}',
    ' · неизвестный исход → следующий канал': ' · unknown outcome → next channel',
    'цель «{event}»': 'goal “{event}”',
    'успех: {result} · дедлайн → {next}': 'success: {result} · deadline → {next}',
    'дальше': 'next',
    'стоп': 'stop',
    'Политики каскада': 'Cascade policies',
    'Порядок каналов, дедлайны, что считать успехом и что делать с неизвестным исходом. Версии неизменяемы: та же политика — та же версия.': 'The order of channels, deadlines, what counts as success and what to do with an unknown outcome. Versions are immutable: the same policy is the same version.',
    'ключ_политики': 'policy_key',
    'Ключ новой политики': 'New policy key',
    'Новая': 'New',
    'Своих политик пока нет': 'No policies of your own yet',
    'Начните со встроенной — первое использование скопирует её в пространство как версию 1.': 'Start from a built-in one — the first use copies it into the workspace as version 1.',
    'Политика {key}: {kind}': 'Policy {key}: {kind}',
    'код подтверждения': 'verification code',
    'из встроенной': 'from built-in',
    'встроенная': 'built-in',
    'в архиве': 'archived',
    ' · потолок {sum}': ' · cap {sum}',
    'ещё не использовалась': 'not used yet',
    'Политика не найдена': 'Policy not found',
    'Проверьте ключ или создайте новую в списке политик.': 'Check the key or create a new one in the policy list.',
    'Без изменений: та же политика — та же версия': 'No changes: the same policy is the same version',
    'Сохранена версия {n}': 'Version {n} saved',
    'Убрать «{key}» в архив? Новые уведомления с ней не создаются; уже идущие доживут по своей версии.': 'Archive “{key}”? New notifications will not be created with it; those already running finish on their own version.',
    'Политика в архиве': 'Policy archived',
    'Все политики': 'All policies',
    'встроенная, ещё не использовалась': 'built-in, not used yet',
    'новая': 'new',
    'проверяю…': 'checking…',
    'есть несохранённые изменения': 'unsaved changes',
    'Тест': 'Test',
    'В архив': 'Archive',
    'Сохраняю…': 'Saving…',
    'Сохранить версию': 'Save version',
    'Редактор': 'Editor',
    'Как код': 'As code',
    'Версии · {n}': 'Versions · {n}',
    'Как это работает': 'How it works',
    'Шаг ждёт свой дедлайн. Пришёл сигнал успеха — каскад останавливается, ещё не отправленные шаги отменяются.': 'A step waits for its deadline. A success signal arrives — the cascade stops and the steps not yet sent are cancelled.',
    'Точный отказ (адреса нет, поставщик отказал, человек заблокировал бота) — сразу следующий шаг.': 'An exact refusal (no address, the provider refused, the person blocked the bot) — the next step goes immediately.',
    'Неизвестный исход (таймаут после отправки) —': 'Unknown outcome (timeout after sending) —',
    ': сообщение могло дойти. Исключение — коды подтверждения: тот же код в следующем канале безопасен.': ': the message may have arrived. Exception — verification codes: the same code on the next channel is safe.',
    'Шаг без адреса, согласия или цены пропускается с причиной — это видно в «Погружении уведомления».': 'A step without an address, consent or price is skipped with a reason — it is shown in the notification deep dive.',
    'Определение политики (JSON)': 'Policy definition (JSON)',
    'JSON не разбирается — изменение не применено': 'Invalid JSON — the change was not applied',
    'Проверено сервером на лету. Нормализованный вид (с умолчаниями) — во вкладке «Версии».': 'Checked by the server on the fly. The normalised view (with defaults) is in the Versions tab.',
    'Политика как код: тот же PUT с тем же определением даёт ту же версию — его безопасно выполнять при каждом деплое.': 'Policy as code: the same PUT with the same definition gives the same version — it is safe to run on every deploy.',
    'Версий нет': 'No versions',
    'Политика ещё не сохранялась.': 'The policy has not been saved yet.',
    'Версия': 'Version',
    'Источник': 'Source',
    'текущая': 'current',
    'кабинет': 'dashboard',
    'Скрыть': 'Hide',
    'Сравнить с v{n}': 'Compare with v{n}',
    'Шаблоны каналов': 'Channel templates',
    'Один шаблон — варианты для SMS, Telegram, push, Web Push, WhatsApp и письма. Каскад берёт вариант того канала, на котором стоит шаг; без варианта шаг пропускается.': 'One template — variants for SMS, Telegram, push, Web Push, WhatsApp and email. The cascade uses the variant of the channel the step is on; without a variant the step is skipped.',
    'Ключ нового шаблона': 'New template key',
    'Новый': 'New',
    'Шаблонов пока нет': 'No templates yet',
    'Создайте первый: например «order_shipped» с вариантами SMS и push.': 'Create the first one, for example “order_shipped” with SMS and push variants.',
    'переменные:': 'variables:',
    'изменён': 'updated',
    'Заказ {{order_id}} отправлен: {{url}}': 'Order {{order_id}} shipped: {{url}}',
    'Заказ отправлен': 'Order shipped',
    'Заказ {{order_id}} уже в пути': 'Order {{order_id}} is on its way',
    'Данные для превью: JSON не разбирается': 'Preview data: JSON cannot be parsed',
    'Шаблон не найден': 'Template not found',
    'Без изменений': 'No changes',
    'Убрать шаблон «{key}» в архив? Новые уведомления с ним не создаются.': 'Archive template “{key}”? New notifications will not be created with it.',
    'Шаблон в архиве': 'Template archived',
    'Все шаблоны': 'All templates',
    'новый': 'new',
    'подставляет значение (в Telegram — с экранированием HTML),': 'substitutes the value (in Telegram — with HTML escaping),',
    '— сырой HTML, только в Telegram. Отсутствующая переменная — ошибка (422), не пустая строка. Коды подтверждения — встроенный шаблон Verify API, здесь не нужен.': '— raw HTML, Telegram only. A missing variable is an error (422), not an empty string. Verification codes use the built-in Verify API template and are not needed here.',
    'Данные для превью (JSON)': 'Preview data (JSON)',
    'Переменные: {list}': 'Variables: {list}',
    'Переменных нет': 'No variables',
    'Версии': 'Versions',
    'Уведомление хранит версию шаблона: изменение не трогает уже отправленные. Сценарии закрепляют версию в своём хеше.': 'A notification keeps the template version: a change does not affect those already sent. Journeys pin the version in their hash.',
    'тест {name}': 'test {name}',
    'Убрать вариант {label}': 'Remove variant {label}',
    'Добавить вариант {label}': 'Add variant {label}',
    'Текст SMS': 'SMS text',
    'Счётчик — по тексту шаблона; после подстановки переменных сегментов может стать больше (цена — за сегмент). Ссылки идут как есть.': 'The counter is based on the template text; after variables are substituted there may be more segments (priced per segment). Links are sent as is.',
    'Сообщение (Telegram HTML)': 'Message (Telegram HTML)',
    'Разрешены <b>, <i>, <u>, <s>, <a href>, <code>, <pre>, <blockquote>': 'Allowed: <b>, <i>, <u>, <s>, <a href>, <code>, <pre>, <blockquote>',
    'Кнопка со ссылкой': 'Button with a link',
    'Открыть': 'Open',
    'Текст кнопки': 'Button text',
    'Ссылка кнопки': 'Button link',
    'Заголовок': 'Title',
    'Текст': 'Text',
    'Ссылка по нажатию (https)': 'Tap link (https)',
    'Иконка (https)': 'Icon (https)',
    'Не скрывать, пока не нажмут': 'Keep showing until dismissed',
    'Web Push — до 3 993 байт JSON вместе с подстановками.': 'Web Push — up to 3,993 bytes of JSON including substitutions.',
    'Картинка (https, необязательно)': 'Image (https, optional)',
    'WhatsApp (шаблон Meta)': 'WhatsApp (Meta template)',
    'Вне окна 24 ч WhatsApp пропускает только одобренный шаблон Meta. Сопоставьте его параметры': 'Outside the 24 h window WhatsApp only passes an approved Meta template. Map its parameters',
    '… с переменными уведомления.': '… with the notification variables.',
    'Имя шаблона Meta': 'Meta template name',
    'Язык': 'Language',
    'Категория': 'Category',
    'Параметр {n}': 'Parameter {n}',
    'Убрать параметр {n}': 'Remove parameter {n}',
    'Параметр': 'Parameter',
    'Сообщение в открытом окне 24 ч (необязательно)': 'Message in the open 24 h window (optional)',
    'Свободный текст — только если человек сам написал вам за последние 24 часа': 'Free text — only if the person wrote to you in the last 24 hours',
    'Отправитель': 'Sender',
    'Адрес на подтверждённом домене': 'Address on a verified domain',
    'Тема': 'Subject',
    'Текст письма': 'Email body',
    'Email-шаг создаёт обычное письмо: его путь виден в «Письма», ссылка — в погружении уведомления.': 'An email step creates a regular email: its path is visible in Emails, the link in the notification deep dive.',
    'шаблон': 'template',
    'Подключено и проверено': 'Connected and verified',
    'Сохранено, но проверка не прошла: {error}': 'Saved, but the check failed: {error}',
    'ошибка поставщика': 'provider error',
    'Название (для вас)': 'Name (for you)',
    'Файл больше 20 КБ — это не похоже на ключ': 'The file is larger than 20 KB — this does not look like a key',
    'файл прочитан ({n} символов) — уйдёт на сервер запечатанным': 'file read ({n} characters) — it will be sent to the server sealed',
    'Проверяю…': 'Checking…',
    'Подключить и проверить': 'Connect and check',
    'Заполните: {fields}': 'Fill in: {fields}',
    'Секреты хранятся запечатанными и обратно не показываются — только «секрет сохранён». Проверка ничего не отправляет людям.': 'Secrets are stored sealed and are never shown again — only “secret saved”. The check sends nothing to people.',
    'Аккаунтов нет.': 'No accounts.',
    'Проверка прошла': 'Check passed',
    'Проверка не прошла: {error}': 'Check failed: {error}',
    'Отключить «{name}»? Шаги через этот аккаунт будут пропускаться (channel_not_configured).': 'Disable “{name}”? Steps through this account will be skipped (channel_not_configured).',
    'аккаунт MailOcean': 'MailOcean account',
    'Проверить': 'Check',
    'Адрес вебхука': 'Webhook address',
    'Отключить {name}': 'Disable {name}',
    'Бот:': 'Bot:',
    'секрет сохранён · обновлён {time}': 'secret saved · updated {time}',
    'Последняя проверка: {error}': 'Last check: {error}',
    'Адрес вебхука бота (MailOcean ставит его сам через setWebhook; показан для диагностики)': 'The bot webhook address (MailOcean sets it itself via setWebhook; shown for diagnostics)',
    'Адрес вебхука для консоли поставщика': 'Webhook address for the provider console',
    ' · режим {mode}': ' · mode {mode}',
    'Verify token (показывается один раз):': 'Verify token (shown once):',
    'активен': 'active',
    'недействителен': 'invalid',
    'отозван': 'revoked',
    'кодом': 'by code',
    'кнопкой Start': 'by the Start button',
    'импортом': 'by import',
    'по API': 'via API',
    'отправлено': 'sent',
    'Передано поставщику': 'Handed to the provider',
    'принято': 'accepted',
    'доставлено': 'delivered',
    'прочитано': 'read',
    'в очереди': 'queued',
    'передан': 'handed over',
    'Telegram-бот': 'Telegram bot',
    'Мобильный push': 'Mobile push',
    'Письма через ваш домен — как в разделе «Письма».': 'Emails sent from your domain — as in the Emails section.',
    'Платформенный SMS MailOcean: подключать ничего не нужно, оплата в счёте.': 'MailOcean platform SMS: nothing to connect, billed on your invoice.',
    'Ваш WhatsApp Business (WABA): шаблоны Meta, окно 24 ч. Meta выставляет счёт вам напрямую.': 'Your WhatsApp Business (WABA): Meta templates, 24 h window. Meta bills you directly.',
    'Ваш бот: человек сам привязывает чат ссылкой. Бесплатно, но бот не сообщает «доставлено».': 'Your bot: the person links the chat themselves via a link. Free, but the bot does not report “delivered”.',
    'Коды подтверждения в Telegram по номеру телефона. Оплачивается вашим аккаунтом Telegram.': 'Confirmation codes in Telegram by phone number. Billed to your Telegram account.',
    'Ваше мобильное приложение через FCM и APNs. Доставку видно только по квитанциям приложения.': 'Your mobile app via FCM and APNs. Delivery is visible only through app receipts.',
    'Уведомления в браузере на вашем сайте. Ключи VAPID MailOcean создаёт сам, бесплатно.': 'Browser notifications on your site. MailOcean creates the VAPID keys itself, free of charge.',
    'Поставщик принял сообщение. Это ещё не значит, что оно дошло.': 'The provider accepted the message. That does not mean it has arrived yet.',
    'Доставлено по отчёту оператора или по квитанции нашего SDK.': 'Delivered per the carrier report or our SDK receipt.',
    'Открыто или нажато по событию канала (квитанция, статус read).': 'Opened or clicked per a channel event (receipt, read status).',
    'Тестовый поставщик': 'Test provider',
    'в плане': 'planned',
    'пропущен': 'skipped',
    'ждёт тихих часов': 'waiting for quiet hours',
    'принят каналом': 'accepted by channel',
    'неизвестный исход': 'unknown outcome',
    'у получателя нет адреса в этом канале': 'the recipient has no address on this channel',
    'адрес недоступен: отозван, недействителен или не подходит каналу (например, стационарный номер для SMS)': 'address unavailable: revoked, invalid or not suitable for the channel (for example, a landline number for SMS)',
    'канал не подключён или аккаунт не проверен': 'channel not connected or account not verified',
    'канал на паузе': 'channel paused',
    'нет согласия на этот канал и цель': 'no consent for this channel and purpose',
    'адрес в подавлениях канала': 'address is on the channel suppression list',
    'тихие часы получателя': 'recipient quiet hours',
    'страна номера не разрешена в настройках': 'the number’s country is not allowed in settings',
    'частотный лимит контакта': 'contact frequency cap',
    'шаг дороже потолка цены уведомления': 'step costs more than the notification price cap',
    'исчерпан дневной лимит расходов': 'daily spend limit reached',
    'в шаблоне нет варианта для этого канала': 'the template has no variant for this channel',
    'окно WhatsApp 24 ч закрыто, а шаблона Meta нет': 'WhatsApp 24 h window closed and no Meta template',
    'Идёт': 'Running',
    'Каскад ещё работает: ждём сигнала или дедлайна шага': 'The cascade is still running: waiting for a signal or the step deadline',
    'Цель достигнута': 'Goal reached',
    'Достигнут сигнал успеха политики': 'The policy success signal was reached',
    'Не отправлено': 'Not sent',
    'Каждый шаг пропущен или получил точный отказ': 'Every step was skipped or got an exact refusal',
    'Остановлено': 'Stopped',
    'Отправлено, подтверждения нет — дальше не шлём, чтобы не продублировать': 'Sent, but no confirmation — we stop here so nothing is duplicated',
    'Отменено': 'Cancelled',
    'Отменено до передачи; переданные шаги не отзываются': 'Cancelled before handover; steps already handed over cannot be recalled',
    'Срок кода истёк': 'Code expired',
    'Код не ввели вовремя': 'The code was not entered in time',
    'Неизвестный исход шага: сообщение могло дойти, поэтому дальше не шлём, чтобы не продублировать.': 'Unknown step outcome: the message may have arrived, so we stop here to avoid duplicates.',
    'Дедлайн шага прошёл без сигнала, а политика велит остановиться (on_timeout: stop).': 'The step deadline passed with no signal, and the policy says to stop (on_timeout: stop).',
    'Шаги закончились: хотя бы один принят каналом, но подтверждения успеха нет.': 'The steps ran out: at least one was accepted by a channel, but there is no success confirmation.',
    'Уведомление создано': 'Notification created',
    'Шаг запланирован': 'Step planned',
    'Шаг пропущен': 'Step skipped',
    'Ждёт тихих часов': 'Waiting for quiet hours',
    'Поставлен в очередь': 'Queued',
    'Удержан': 'Held',
    'Передан поставщику': 'Handed to provider',
    'Повтор (поставщик точно не принял)': 'Retry (provider definitely did not accept)',
    'Нажато': 'Clicked',
    'Отказ': 'Bounce',
    'Заменён другим маршрутом': 'Replaced by another route',
    'Деньги возвращены': 'Money refunded',
    'Цена от поставщика': 'Price from provider',
    'Дедлайн шага': 'Step deadline',
    'Переход к следующему шагу': 'Moving to the next step',
    'Сигнал от вашего сервера': 'Signal from your server',
    'Введён неверный код': 'Wrong code entered',
    'Код подтверждён': 'Code confirmed',
    'Успех политики': 'Policy success',
    'Уведомление завершено': 'Notification finished',
    'Сверено сотрудником MailOcean': 'Reconciled by a MailOcean employee',
    'Письмо в очереди': 'Email queued',
    'Письмо передано провайдеру': 'Email handed to provider',
    'Письмо принято провайдером': 'Email accepted by provider',
    'Письмо доставлено': 'Email delivered',
    'Письмо отскочило': 'Email bounced',
    'Исход письма неизвестен': 'Email outcome unknown',
    'Письмо отменено': 'Email cancelled',
    'Письмо не отправлено': 'Email not sent',
    'Чат Telegram': 'Telegram chat',
    'Устройство Android/FCM': 'Android/FCM device',
    'Устройство iOS/APNs': 'iOS/APNs device',
    'Подписка Web Push': 'Web Push subscription',
    'согласие': 'consent',
    'отзыв': 'withdrawal',
    'нет записи': 'no record',
    'ответил STOP': 'replied STOP',
    'заблокировал': 'blocked',
    'адрес недействителен': 'address invalid',
    'жалоба': 'complaint',
    'вручную': 'manually',
    'Австрия': 'Austria',
    'Бельгия': 'Belgium',
    'Болгария': 'Bulgaria',
    'Хорватия': 'Croatia',
    'Кипр': 'Cyprus',
    'Чехия': 'Czechia',
    'Дания': 'Denmark',
    'Эстония': 'Estonia',
    'Финляндия': 'Finland',
    'Франция': 'France',
    'Германия': 'Germany',
    'Греция': 'Greece',
    'Венгрия': 'Hungary',
    'Ирландия': 'Ireland',
    'Италия': 'Italy',
    'Латвия': 'Latvia',
    'Литва': 'Lithuania',
    'Люксембург': 'Luxembourg',
    'Мальта': 'Malta',
    'Нидерланды': 'Netherlands',
    'Польша': 'Poland',
    'Португалия': 'Portugal',
    'Румыния': 'Romania',
    'Словакия': 'Slovakia',
    'Словения': 'Slovenia',
    'Испания': 'Spain',
    'Швеция': 'Sweden',
    'Исландия': 'Iceland',
    'Лихтенштейн': 'Liechtenstein',
    'Норвегия': 'Norway',
    'Уведомления': 'Notifications',
    'Шаблоны': 'Templates',
    'Расходы': 'Costs',
    'Настройки': 'Settings',
    'Регион': 'Region',
    'Ireland (IE1) — данные в ЕС': 'Ireland (IE1) — data in the EU',
    'Имя отправителя (Alphanumeric Sender ID)': 'Sender name (alphanumeric Sender ID)',
    'До 11 латинских букв и цифр; или Messaging Service SID ниже': 'Up to 11 Latin letters and digits; or the Messaging Service SID below',
    'Messaging Service SID (необязательно)': 'Messaging Service SID (optional)',
    'API Key SID региона': 'Regional API Key SID',
    'Auth Token региона': 'Regional Auth Token',
    'Им Twilio подписывает отчёты о доставке — без него статусы не принимаются': 'Twilio signs delivery reports with it — without it statuses are not accepted',
    'Имя отправителя': 'Sender name',
    'Постоянный токен системного пользователя': 'Permanent system user token',
    'Права whatsapp_business_messaging и whatsapp_business_management, срок «Never»': 'Scopes whatsapp_business_messaging and whatsapp_business_management, expiry “Never”',
    'Им Meta подписывает вебхуки (X-Hub-Signature-256)': 'Meta signs webhooks with it (X-Hub-Signature-256)',
    'Токен бота от @BotFather': 'Bot token from @BotFather',
    'Ответ на /start': 'Reply to /start',
    'Готово! Теперь уведомления о заказах придут сюда.': 'Done! Order notifications will now arrive here.',
    'API-токен Telegram Gateway': 'Telegram Gateway API token',
    'Ключ сервисного аккаунта (JSON)': 'Service account key (JSON)',
    'Приложение шлёт квитанции (доставлено/нажато)': 'The app sends receipts (delivered/clicked)',
    'Без квитанций push сообщает только «принято»': 'Without receipts push reports only “accepted”',
    'Ключ APNs (.p8)': 'APNs key (.p8)',
    'Скачивается один раз в Certificates, IDs & Profiles → Keys. Обратно не показывается': 'Downloaded once from Certificates, IDs & Profiles → Keys. Not shown again',
    'Bundle ID приложения': 'App bundle ID',
    'Среда': 'Environment',
    'sandbox (dev-сборки)': 'sandbox (dev builds)',
    'работает': 'running',
    'сбоит': 'failing',
    'отключён': 'disabled',
  },
  uk: {
    'Номер добавлен. Для SMS, WhatsApp и Gateway нужно согласие или аттестация — запишите его.': 'Номер додано. Для SMS, WhatsApp і Gateway потрібна згода або атестація — запишіть її.',
    'Убрали лишние символы: {fix}. Проверьте номер и нажмите «Добавить».': 'Прибрано зайві символи: {fix}. Перевірте номер і натисніть «Додати».',
    '{message}. Может быть, {suggest}?': '{message}. Можливо, {suggest}?',
    'Отозвать адрес {hint}? Шаги каналов на него перестанут уходить; подавления не меняются.': 'Відкликати адресу {hint}? Кроки каналів на неї більше не надходитимуть; придушення не змінюються.',
    'Каналы': 'Канали',
    'Номер': 'Номер',
    'Ссылка для Telegram': 'Посилання для Telegram',
    'Телефон в формате E.164': 'Телефон у форматі E.164',
    'Добавить': 'Додати',
    'Подставить': 'Підставити',
    'Загружаю…': 'Завантажую…',
    'Адресов в каналах нет. Телефон добавляется здесь или по API; Telegram, push и Web Push — только привязкой самим человеком.': 'Адреси в каналах відсутні. Телефон додається тут або через API; Telegram, push і Web Push — лише прив’язкою самою людиною.',
    'проверен {how}': 'перевірено {how}',
    'не проверен': 'не перевірено',
    'Согласие': 'Згода',
    'Отозвать {hint}': 'Відкликати {hint}',
    'Сервисные': 'Сервісні',
    'серв.: {status}': 'серв.: {status}',
    'Маркетинг': 'Маркетинг',
    'марк.: {status}': 'марк.: {status}',
    'подавлен': 'придушено',
    'Недоступен в:': 'Недоступно в:',
    'Подавления каналов:': 'Придушення каналів:',
    'всё': 'усе',
    'маркетинг': 'маркетинг',
    'Подавление сильнее согласия.': 'Придушення сильніше за згоду.',
    'Журнал согласий по каналам · {n}': 'Журнал згод за каналами · {n}',
    'сервисные': 'сервісні',
    'записано {time}': 'записано {time}',
    'кто записал: {name}': 'хто записав: {name}',
    'доказательство не приложено': 'доказ не додано',
    'Последние уведомления': 'Останні сповіщення',
    'код': 'код',
    'сервисное': 'сервісне',
    'Записано в журнал согласий': 'Записано в журнал згод',
    'Согласие · {hint}': 'Згода · {hint}',
    'Отмена': 'Скасувати',
    'Записать': 'Записати',
    'Канал': 'Канал',
    'Цель': 'Мета',
    'Отзыв': 'Відкликання',
    'Источник (обязательно)': 'Джерело (обов’язково)',
    'Откуда согласие: checkout_form, phone_call, support…': 'Звідки згода: checkout_form, phone_call, support…',
    'Доказательство': 'Доказ',
    'Обязательно для согласия: как и когда получено': 'Обов’язково для згоди: як і коли її отримано',
    'Необязательно': 'Необов’язково',
    'Галочка «Получать SMS о заказе» при оформлении заказа A-1042': 'Галочка «Отримувати SMS про замовлення» під час оформлення замовлення A-1042',
    'Подавление сильнее согласия: новая запись «согласие» его не снимает.': 'Придушення сильніше за згоду: новий запис «згода» його не знімає.',
    'Политика каскада': 'Політика каскаду',
    'Только «сообщение»: коды отправляет Verify API.': 'Лише «повідомлення»: коди надсилає Verify API.',
    'Политики': 'Політики',
    '— выберите —': '— оберіть —',
    ' (встроенная)': ' (вбудована)',
    '{key} (не найдена)': '{key} (не знайдено)',
    'Версия политики': 'Версія політики',
    'Закрепляется в версии сценария: изменение политики потом не меняет одобренный сценарий': 'Закріплюється у версії сценарію: подальша зміна політики не змінює погоджений сценарій',
    'последняя (сейчас v{version})': 'остання (зараз v{version})',
    'Худший случай:': 'Найгірший випадок:',
    'на участника': 'на учасника',
    'Обычно дешевле — каскад останавливается на успехе.': 'Зазвичай дешевше — каскад зупиняється на успіху.',
    'Маркетинговому уведомлению нужна политика с «если нет сигнала — остановиться»: иначе человек может получить сообщение дважды. Сохранение версии сценария это не пропустит.': 'Маркетинговому сповіщенню потрібна політика «якщо немає сигналу — зупинитися»: інакше людина може отримати повідомлення двічі. Збереження версії сценарію цього не пропустить.',
    'Шаблон канала': 'Шаблон каналу',
    'Шаблонов нет — создайте в «Каналы → Шаблоны»': 'Шаблонів немає — створіть у «Канали → Шаблони»',
    '{key} (не найден)': '{key} (не знайдено)',
    'Версия шаблона': 'Версія шаблону',
    '— варианты шаблона; шаг без варианта пропускается': '— варіанти шаблону; крок без варіанту пропускається',
    'Переменные шаблона': 'Змінні шаблону',
    'Путь — начинается с «=»: =contact.attributes.first_name; иначе — постоянное значение': 'Шлях починається з «=»: =contact.attributes.first_name; інакше — стале значення',
    'Источник {name}': 'Джерело {name}',
    'по умолч.': 'за замовч.',
    'Значение по умолчанию {name}': 'Значення за замовчуванням для {name}',
    'Поток': 'Потік',
    'Маркетинг: нужно согласие на канал, тихие часы и частотный лимит': 'Маркетинг: потрібні згода на канал, тихі години та частотний ліміт',
    'Сервисное: без согласия на маркетинг; согласующий подтверждает, что рекламы нет': 'Сервісне: без згоди на маркетинг; погоджувач підтверджує, що реклами немає',
    'как у сценария ({kind})': 'як у сценарію ({kind})',
    'транзакционные': 'транзакційні',
    'транзакционные (сервисные)': 'транзакційні (сервісні)',
    'Если все каналы пропущены': 'Якщо всі канали пропущено',
    'Нет адреса, согласия, подавление, тихие часы, лимит': 'Немає адреси, згоди, придушення, тихих годин або ліміту',
    'идти дальше': 'продовжити',
    'завершить участие': 'завершити участь',
    'Шаг перемещён на позицию {n}': 'Крок переміщено на позицію {n}',
    'Шаг {n} поднят. Стрелки вверх и вниз — переместить, пробел — опустить, Esc — отмена.': 'Крок {n} піднято. Стрілки вгору і вниз — перемістити, пробіл — опустити, Esc — скасувати.',
    'Шаг опущен на позицию {n}': 'Крок опущено на позицію {n}',
    'Позиция {n} из {total}': 'Позиція {n} з {total}',
    'Перемещение отменено': 'Переміщення скасовано',
    'Вид политики': 'Тип політики',
    'Сообщение': 'Повідомлення',
    'Код подтверждения': 'Код підтвердження',
    'Успех — только введённый код. Во всех каналах уходит': 'Успіх — лише введений код. У всіх каналах надсилається',
    'один и тот же код': 'той самий код',
    ', поэтому после дедлайна шага всегда идёт следующий канал; email — только последним (тело письма хранится).': ', тож після дедлайну кроку завжди йде наступний канал; email — лише останнім (текст листа зберігається).',
    'Что считать успехом': 'Що вважати успіхом',
    'Каскад идёт дальше, пока этого сигнала нет к дедлайну шага': 'Каскад іде далі, поки цього сигналу немає до дедлайну кроку',
    'Принято каналом': 'Прийнято каналом',
    'Доставлено (по отчёту оператора)': 'Доставлено (за звітом оператора)',
    'Прочитано': 'Прочитано',
    'Цель — событие вашего сервера': 'Мета — подія з вашого сервера',
    'Событие цели': 'Подія мети',
    'POST /v1/events с этим именем или POST /v1/notifications/:id/signal': 'POST /v1/events з цією назвою або POST /v1/notifications/:id/signal',
    'Длина кода': 'Довжина коду',
    'Срок кода, с': 'Термін коду, с',
    'Попыток ввода': 'Спроб введення',
    'Шаги каскада': 'Кроки каскаду',
    'по порядку; перетащите за ручку или клавиатурой': 'за порядком; перетягніть за ручку або клавіатурою',
    'Цены для': 'Ціни для',
    'Страна-образец для цены': 'Країна-зразок для ціни',
    'Шаг {n}: {channel}. Переместить': 'Крок {n}: {channel}. Перемістити',
    'Дедлайн (последний — необязательно), с': 'Дедлайн (останній — необов’язково), с',
    'Дедлайн, с': 'Дедлайн, с',
    'ждать сигнала': 'чекати сигналу',
    'Успех шага': 'Успіх кроку',
    'как у политики': 'як у політиці',
    'сообщает максимум:': 'повідомляє максимум:',
    'ждём {time}': 'чекаємо {time}',
    'цена шага:': 'ціна кроку:',
    'нет в прайсе': 'немає в прайсі',
    ' (ваш аккаунт, ориентировочно)': ' (ваш акаунт, орієнтовно)',
    ' (бесплатно)': ' (безкоштовно)',
    'не подключён': 'не підключено',
    'Шаг без цены не выполняется: деньги не тратятся вслепую': 'Крок без ціни не виконується: гроші не витрачаються наосліп',
    'шаг не выполнится': 'крок не виконається',
    'Шаг {n} выше': 'Крок {n} вище',
    'Шаг {n} ниже': 'Крок {n} нижче',
    'Удалить шаг {n}': 'Видалити крок {n}',
    'Добавить шаг': 'Додати крок',
    'Параллельно с каскадом': 'Паралельно з каскадом',
    'Уходят сразу и не отменяются успехом каскада (например, письмо-копия)': 'Надсилаються одразу і не скасовуються успіхом каскаду (наприклад, копія листа)',
    'Потолок цены уведомления, €': 'Стеля ціни сповіщення, €',
    'Шаг дороже остатка пропускается (over_budget)': 'Крок дорожчий за залишок пропускається (over_budget)',
    'без потолка': 'без стелі',
    'Тихие часы получателя': 'Тихі години одержувача',
    'не учитывать (сервисные)': 'не враховувати (сервісні)',
    'ждать утра': 'чекати ранку',
    'пропустить шаг': 'пропустити крок',
    'Страны (через запятую)': 'Країни (через кому)',
    'Пусто — разрешённые страны пространства': 'Порожньо — дозволені країни простору',
    'Если исход шага неизвестен': 'Якщо результат кроку невідомий',
    'остановиться (не дублировать)': 'зупинитися (не дублювати)',
    'следующий канал': 'наступний канал',
    ' — только для кодов': ' — лише для кодів',
    'Если к дедлайну нет сигнала': 'Якщо до дедлайну немає сигналу',
    'остановиться': 'зупинитися',
    'Человек может получить сообщение дважды.': 'Людина може отримати повідомлення двічі.',
    'При неизвестном исходе следующий канал получит тот же код — дубль безопасен, потерянный вход хуже.': 'За невідомого результату наступний канал отримає той самий код — дубль безпечний, втрачений вхід гірший.',
    'Если первый канал доставил, но не сообщил об этом к дедлайну, следующий канал продублирует сообщение. Для маркетинга в сценариях это запрещено.': 'Якщо перший канал доставив, але не повідомив про це до дедлайну, наступний канал продублює повідомлення. Для маркетингу в сценаріях це заборонено.',
    'Худший случай для {country}:': 'Найгірший випадок для {country}:',
    '— если каждый шаг дойдёт до поставщика. Обычно дешевле: каскад останавливается на успехе.': '— якщо кожен крок дійде до провайдера. Зазвичай дешевше: каскад зупиняється на успіху.',
    'Канал не сообщает такой сигнал': 'Канал не повідомляє такого сигналу',
    'Политика не прошла проверку': 'Політика не пройшла перевірку',
    'QR-код ссылки привязки': 'QR-код посилання для прив’язки',
    'Подключите бота, чтобы создавать ссылки.': 'Підключіть бота, щоб створювати посилання.',
    'Контакт': 'Контакт',
    'Бот': 'Бот',
    'Человек также соглашается на маркетинговые сообщения': 'Людина також погоджується на маркетингові повідомлення',
    'Создать ссылку': 'Створити посилання',
    'Одноразовая, действует до {time}. Человек нажимает «Start» — чат привязывается к контакту.': 'Одноразове, діє до {time}. Людина натискає «Start» — чат прив’язується до контакту.',
    ' (может быть, {suggest}?)': ' (можливо, {suggest}?)',
    '{n} симв.': '{n} симв.',
    'сегмент': 'сегмент',
    'сегмента': 'сегменти',
    'сегментов': 'сегментів',
    'осталось {n} в последнем': 'залишилось {n} в останньому',
    'Unicode из-за: {chars} — сегмент 70 вместо 160 знаков': 'Unicode через: {chars} — 70 знаків у сегменті замість 160',
    'тест {v}': 'тест {v}',
    'Данные: JSON не разбирается': 'Дані: JSON не розбирається',
    'Код верный: каскад остановлен, следующие шаги отменены': 'Код правильний: каскад зупинено, наступні кроки скасовано',
    'Статус: {status}': 'Статус: {status}',
    'Неверный код, осталось попыток: {n}': 'Неправильний код, залишилось спроб: {n}',
    'Неверный код': 'Неправильний код',
    'Верификация уже не ждёт кода (подтверждена, истекла или попытки кончились)': 'Верифікація вже не чекає коду (підтверджено, минув термін або спроби вичерпано)',
    'Тестовый код подтверждения': 'Тестовий код підтвердження',
    'Тестовая отправка': 'Тестове надсилання',
    'Закрыть': 'Закрити',
    'Смотреть погружение': 'Переглянути занурення',
    'Отправляю…': 'Надсилаю…',
    'Отправить код': 'Надіслати код',
    'Отправить': 'Надіслати',
    'сообщение': 'повідомлення',
    'Варианты: {list}': 'Варіанти: {list}',
    'Создайте шаблон в «Каналы → Шаблоны»': 'Створіть шаблон у «Канали → Шаблони»',
    'Получатель': 'Отримувач',
    'Телефон': 'Телефон',
    'Мой email': 'Мій email',
    'Номер в формате E.164': 'Номер у форматі E.164',
    'С тестовым поставщиком исход решает последняя цифра: 1 — отказ, 2 — неизвестно, 3 — отказ после приёма, 6 — без отчёта, иначе — доставлено': 'З тестовим провайдером результат визначає остання цифра: 1 — відмова, 2 — невідомо, 3 — відмова після прийняття, 6 — без звіту, інакше — доставлено',
    'Id контакта': 'ID контакту',
    'Шаги пойдут по адресам контакта: телефон, Telegram, push, web push': 'Кроки підуть на адреси контакту: телефон, Telegram, push, web push',
    'Только email-шаги дойдут: на ваш адрес {email}. Остальные каналы пропустятся — у вас как участника нет в них адреса.': 'Дійдуть лише кроки email: на вашу адресу {email}. Решта каналів пропуститься — як учасник, ви не маєте в них адреси.',
    'Данные шаблона (JSON)': 'Дані шаблону (JSON)',
    'Тестовая отправка — настоящая: платные шаги учитываются в расходах. Не больше 10 в час на пространство.': 'Це справжнє тестове надсилання: платні кроки враховуються у витратах. Не більше 10 на годину на простір.',
    'Уведомление': 'Сповіщення',
    'создано. Худший случай по цене:': 'створено. Найгірша ціна:',
    'Введите код из сообщения': 'Введіть код із повідомлення',
    'Верный код останавливает каскад: шаги, ещё не переданные поставщику, отменяются': 'Правильний код зупиняє каскад: кроки, ще не передані провайдеру, скасовуються',
    'Проверить код': 'Перевірити код',
    'Тестовый телефон': 'Тестовий телефон',
    'только вне production': 'лише поза production',
    'Здесь появятся сообщения, которые получил бы человек от тестового поставщика.': 'Тут з’являтимуться повідомлення, які отримала б людина від тестового провайдера.',
    'шаблон Meta «{name}»': 'шаблон Meta «{name}»',
    'код:': 'код:',
    'Тестовый поставщик: сообщения никуда не уходят': 'Тестовий провайдер: повідомлення нікуди не надсилаються',
    'тестовый': 'тестовий',
    'Проверено от начала до конца': 'Перевірено наскрізно',
    'проверено': 'перевірено',
    'Адаптер написан по официальной документации поставщика, но ещё не проверен на настоящем аккаунте': 'Адаптер написано за офіційною документацією провайдера, але ще не перевірено на справжньому акаунті',
    'не проверено на живом аккаунте': 'не перевірено на живому акаунті',
    '{channel} не сообщает этот сигнал': '{channel} не повідомляє цей сигнал',
    'За 7 дней: факт поставщика, до его прихода — оценка': 'За 7 днів: фактичні дані провайдера; до їх надходження — оцінка',
    'стоимость': 'вартість',
    'Шаг {seq} — неизвестный исход: дальше не шлём, чтобы не продублировать.': 'Крок {seq} — невідомий результат: далі не надсилаємо, щоб не дублювати.',
    'Исход шага {seq} был неизвестен; сотрудник MailOcean сверил его вручную ({result}). Каскад не возобновляется.': 'Результат кроку {seq} був невідомий; працівник MailOcean звірив його вручну ({result}). Каскад не відновлюється.',
    'принято поставщиком': 'прийнято провайдером',
    'не принято': 'не прийнято',
    'код {code}': 'код {code}',
    'попытка {n}': 'спроба {n}',
    '{n} сегм.': '{n} сегм.',
    'через {via}': 'через {via}',
    'параллельно': 'паралельно',
    'шаг {seq}': 'крок {seq}',
    'успех здесь': 'успіх тут',
    'Факт по данным поставщика': 'Факт за даними постачальника',
    'Оценка до отчёта поставщика': 'Оцінка до звіту провайдера',
    'не оплачивается': 'не оплачується',
    'факт {sum}': 'факт {sum}',
    'оценка {sum}': 'оцінка {sum}',
    'ваш аккаунт': 'ваш акаунт',
    'дедлайн {n}': 'дедлайн {n}',
    'письмо {id}…': 'лист {id}…',
    'Пропущен: {reason}.': 'Пропущено: {reason}.',
    'Сверено сотрудником MailOcean вручную: {result}. Время приёма у поставщика неизвестно; каскад не возобновляется.': 'Звірено вручну працівником MailOcean: {result}. Час прийняття провайдером невідомий; каскад не відновлюється.',
    'поставщик принял сообщение': 'провайдер прийняв повідомлення',
    'поставщик сообщение не принял': 'провайдер повідомлення не прийняв',
    'Отказ поставщика:': 'Відмова провайдера:',
    ' — точный отказ, можно идти дальше.': ' — точна відмова, можна йти далі.',
    'Неизвестный исход: поставщик мог принять сообщение. Повтора не будет': 'Невідомий результат: провайдер міг прийняти повідомлення. Повтору не буде',
    '; у кода подтверждения следующий канал получает тот же код.': '; наступний канал отримає той самий код, бо це код підтвердження.',
    ' — дальше не шлём, чтобы не продублировать.': ' — далі не надсилаємо, щоб не дублювати.',
    'события шага · {n}': 'події кроку · {n}',
    'Каскад остановлен.': 'Каскад зупинено.',
    'Не отправлено ни в один канал.': 'Не надіслано жодним каналом.',
    'Каждый шаг пропущен или получил точный отказ — причины ниже.': 'Кожен крок пропущено або отримав точну відмову — причини нижче.',
    'Срок кода истёк.': 'Термін коду минув.',
    'Код не ввели вовремя; запечатанная копия кода удалена.': 'Код не ввели вчасно; запечатану копію коду видалено.',
    'Отменено.': 'Скасовано.',
    'Шаги, ещё не переданные поставщику, отменены; переданные не отзываются.': 'Кроки, ще не передані провайдеру, скасовано; передані не відкликаються.',
    'Параллельно с каскадом (не отменяются его успехом)': 'Паралельно з каскадом (не скасовуються його успіхом)',
    'события уведомления · {n}': 'події сповіщення · {n}',
    'цены нет': 'ціни немає',
    '{n} с': '{n} с',
    '{n} мин': '{n} хв',
    '{n} ч': '{n} год',
    '{n} мс': '{n} мс',
    '{m} мин {s} с': '{m} хв {s} с',
    '// Та же политика = та же версия: повтор безопасен': '// Та сама політика = та сама версія: повтор безпечний',
    '// SDK ставит Idempotency-Key сам и повторяет запрос с тем же ключом': '// SDK сам ставить Idempotency-Key і повторює запит із тим самим ключем',
    'Все каналы': 'Усі канали',
    'Подключение': 'Підключення',
    'Логи канала': 'Журнал каналу',
    'Неизвестные исходы': 'Невідомі результати',
    'Тестовый {channel}': 'Тестовий {channel}',
    'Тестовый поставщик подключён: сообщения никуда не уходят': 'Тестовий провайдер підключено: повідомлення нікуди не надсилаються',
    'Без аккаунта поставщика?': 'Немає акаунта провайдера?',
    'Подключите тестовый поставщик (только вне production): исход решает последняя цифра адреса, сообщения видны в «Тестовом телефоне».': 'Підключіть тестового провайдера (лише поза production): результат визначає остання цифра адреси, повідомлення видно в «Тестовому телефоні».',
    'Подключить тестовый': 'Підключити тестового',
    'Аттестация отозвана': 'Атестацію відкликано',
    'Аттестация записана в журнал': 'Атестацію записано в журнал',
    'Аттестация согласий': 'Атестація згод',
    'Сервисные сообщения WhatsApp идут без согласия по каждому адресу только после письменного подтверждения владельца. Без него шаг пропускается с причиной «нет согласия».': 'Сервісні повідомлення WhatsApp надсилаються без згоди за кожною адресою лише після письмового підтвердження власника. Без нього крок пропускається з причиною «немає згоди».',
    'Telegram Gateway требует, чтобы коды получали только те, кто сам их запросил (условия Telegram).': 'Telegram Gateway вимагає, щоб коди отримували лише ті, хто їх сам запросив (умови Telegram).',
    'версия {n}': 'версія {n}',
    'подтверждено': 'підтверджено',
    'версия текста {n}': 'версія тексту {n}',
    'Отозвать': 'Відкликати',
    'Подтверждаю': 'Підтверджую',
    'Подтвердить может только владелец пространства.': 'Підтвердити може лише власник простору.',
    'Аттестации нет.': 'Атестації немає.',
    'Платформенный SMS MailOcean': 'Платформенний SMS MailOcean',
    'Подключать ничего не нужно: MailOcean отправляет через своих операторов (Twilio IE1, Messente) и выставляет SMS в счёт с наценкой.': 'Нічого підключати не потрібно: MailOcean надсилає через своїх операторів (Twilio IE1, Messente) і виставляє SMS у рахунок з націнкою.',
    'Сейчас SMS идут через тестовый поставщик «{name}». Он играет роль платформенного SMS: цены — с наценкой MailOcean, в «Маяке» оплата видна как «MailOcean», настоящие SMS не уходят.': 'Наразі SMS надсилаються через тестового провайдера «{name}». Він грає роль платформенного SMS: ціни з націнкою MailOcean, у Маяку оплата видна як «MailOcean», справжні SMS не надсилаються.',
    'Сейчас SMS идут через ваш аккаунт «{name}».': 'Наразі SMS надсилаються через ваш акаунт «{name}».',
    'MailOcean ещё не подключил платформенные SMS — подключите свой аккаунт ниже или тестовый поставщик.': 'MailOcean ще не підключив платформенні SMS — підключіть свій акаунт нижче або тестового провайдера.',
    'Имя отправителя по умолчанию — «MailOcean». Своё имя (до 11 символов) регистрируется у операторов: напишите в поддержку, указав имя и страны.': 'Ім’я відправника за замовчуванням — «MailOcean». Власне ім’я (до 11 символів) реєструється у операторів: напишіть у підтримку, вказавши ім’я та країни.',
    'Цены по странам': 'Ціни за країнами',
    'за сообщение, SMS — за сегмент': 'за повідомлення, SMS — за сегмент',
    'Страна': 'Країна',
    'Разрешена': 'Дозволено',
    'Цена': 'Ціна',
    'Действует с': 'Діє з',
    'Разрешить {country}': 'Дозволити {country}',
    'да': 'так',
    'нет': 'ні',
    'Без цены шаг не выполняется': 'Без ціни крок не виконується',
    'нет цены': 'немає ціни',
    'общая': 'спільна',
    'Номера стран вне разрешённых пропускаются с причиной «страна не разрешена».': 'Номери країн поза дозволеним списком пропускаються з причиною «країна не дозволена».',
    'Свой Twilio или Messente': 'Власний Twilio або Messente',
    'Если у вас уже есть договор с оператором: SMS пойдут через ваш аккаунт, оплата — напрямую поставщику, MailOcean их не выставляет в счёт.': 'Якщо у вас уже є договір з оператором: SMS підуть через ваш акаунт, оплата — напряму провайдеру, MailOcean їх не виставляє в рахунок.',
    'Аккаунты WhatsApp Business': 'Акаунти WhatsApp Business',
    'Подключить вручную': 'Підключити вручну',
    'Как подключить': 'Як підключити',
    'В Meta Business Manager создайте приложение типа': 'У Meta Business Manager створіть застосунок типу',
    'и добавьте продукт WhatsApp.': 'і додайте продукт WhatsApp.',
    'Создайте системного пользователя (Admin), назначьте ему приложение и WABA, выпустите постоянный токен с правами': 'Створіть системного користувача (Admin), призначте йому застосунок і WABA, випустіть постійний токен із правами',
    'и': 'і',
    'Скопируйте Phone number ID, WABA ID и App Secret (App settings → Basic) и вставьте в форму.': 'Скопіюйте Phone number ID, WABA ID і App Secret (App settings → Basic) і вставте у форму.',
    'После подключения MailOcean покажет Callback URL и Verify token: вставьте их в WhatsApp → Configuration и подпишитесь на поле': 'Після підключення MailOcean покаже Callback URL і Verify token: вставте їх у WhatsApp → Configuration і підпишіться на поле',
    'Meta выставляет счёт вам напрямую — цены в каскаде ориентировочные (по категории шаблона). Вне окна 24 ч WhatsApp пропускает только одобренные шаблоны.': 'Meta виставляє рахунок вам напряму — ціни в каскаді орієнтовні (за категорією шаблону). Поза вікном 24 год WhatsApp пропускає лише схвалені шаблони.',
    'Шаблонов синхронизировано: {n}': 'Синхронізовано шаблонів: {n}',
    'Шаблоны Meta · {n}': 'Шаблони Meta · {n}',
    'Синхронизировать': 'Синхронізувати',
    'Шаблонов нет или ещё не синхронизированы.': 'Шаблонів немає або їх ще не синхронізовано.',
    'Боты': 'Боти',
    'Добавить бота': 'Додати бота',
    'Бот уведомлений': 'Бот сповіщень',
    'Ссылка привязки для контакта': 'Посилання для прив’язки контакту',
    'Как получить токен у @BotFather': 'Як отримати токен у @BotFather',
    'Откройте в Telegram': 'Відкрийте в Telegram',
    'и отправьте': 'і надішліть',
    'Задайте имя и username, оканчивающийся на': 'Задайте ім’я та username, що закінчується на',
    'BotFather пришлёт токен вида': 'BotFather надішле токен виду',
    'Токен никому не пересылайте.': 'Токен нікому не пересилайте.',
    'Вставьте токен в «Добавить бота». MailOcean проверит его (': 'Вставте токен у «Додати бота». MailOcean перевірить його (',
    ') и сам поставит вебхук.': ') і сам встановить вебхук.',
    'Бот пишет только тем, кто сам нажал «Start» по вашей ссылке. Telegram не сообщает боту «доставлено» и «прочитано» — в каскаде у этого канала только «принято». Если человек заблокирует бота, адрес отзывается и следующий шаг каскада пойдёт дальше.': 'Бот пише лише тим, хто сам натиснув «Start» за вашим посиланням. Telegram не повідомляє боту «доставлено» і «прочитано» — у каскаді цей канал має лише «прийнято». Якщо людина заблокує бота, адресу відкликано і каскад іде далі.',
    'Оплачивается вашим аккаунтом Telegram.': 'Оплачується вашим акаунтом Telegram.',
    'Telegram Gateway списывает плату за каждый код с баланса вашего аккаунта Gateway; MailOcean её не выставляет в счёт. Канал только для кодов подтверждения.': 'Telegram Gateway списує плату за кожен код з балансу вашого акаунта Gateway; MailOcean її не виставляє в рахунок. Канал лише для кодів підтвердження.',
    'Токен Gateway': 'Токен Gateway',
    'Вставить токен': 'Вставити токен',
    'Gateway сам проверяет, есть ли у номера Telegram: если нет — шаг получает точный отказ, и каскад сразу идёт к SMS. Если код использован раньше, MailOcean отзывает сообщение Gateway (деньги за недоставленные коды Telegram возвращает сам).': 'Gateway сам перевіряє, чи є в номера Telegram: якщо ні — крок отримує точну відмову, і каскад одразу йде до SMS. Якщо код уже використано раніше, MailOcean відкликає повідомлення Gateway (гроші за недоставлені коди Telegram повертає сам Telegram).',
    'Приложения': 'Застосунки',
    'квитанции включены: доставка и нажатия видны': 'квитанції увімкнено: доставку і натискання видно',
    'без квитанций: только «принято»': 'без квитанцій: лише «прийнято»',
    'Android-приложение': 'Android-застосунок',
    'iOS-приложение': 'iOS-застосунок',
    'Регистрация устройства': 'Реєстрація пристрою',
    'Ваш сервер передаёт токен устройства после входа пользователя (или приложение — через одноразовый identify-токен). Токены хранятся запечатанными.': 'Ваш сервер передає токен пристрою після входу користувача (або застосунок — через одноразовий identify-токен). Токени зберігаються запечатаними.',
    'Мой сайт': 'Мій сайт',
    'Приложение Web Push создано: ключи VAPID готовы': 'Застосунок Web Push створено: ключі VAPID готові',
    'Ещё один сайт': 'Ще один сайт',
    'Web Push не подключён': 'Web Push не підключено',
    'Укажите адрес сайта — MailOcean создаст ключи VAPID и покажет три шага установки.': 'Вкажіть адресу сайту — MailOcean створить ключі VAPID і покаже три кроки встановлення.',
    'Подключить сайт': 'Підключити сайт',
    'Название': 'Назва',
    'Origin сайта (через запятую)': 'Origin сайту (через кому)',
    'https://shop.example.lv — подписки принимаются только с этих адресов. Вне production можно http://localhost:порт': 'https://shop.example.lv — підписки приймаються лише з цих адрес. Поза production можна http://localhost:порт',
    'Создать ключи': 'Створити ключі',
    'Поддержка браузеров': 'Підтримка браузерів',
    'Chrome, Edge, Firefox, Opera — на компьютере и Android. Safari на macOS — с версии 16. На iPhone и iPad (iOS 16.4+) уведомления работают только у сайта, добавленного на экран «Домой» как веб-приложение (нужен манифест), и только после нажатия пользователя.': 'Chrome, Edge, Firefox, Opera — на комп’ютері та Android. Safari на macOS — з версії 16. На iPhone і iPad (iOS 16.4+) сповіщення працюють лише для сайту, доданого на головний екран як веб-застосунок (потрібен маніфест), і лише після натискання користувача.',
    'Доставку видно по квитанции нашего service worker («доставлено»), нажатие — «прочитано». Подписка, которую браузер отозвал (404/410), помечается недействительной, и каскад идёт к следующему каналу.': 'Доставку видно за квитанцією нашого service worker («доставлено»), натискання — «прочитано». Підписку, яку браузер відкликав (404/410), позначено недійсною, і каскад іде до наступного каналу.',
    'Адреса сайта сохранены': 'Адреси сайту збережено',
    'Этот браузер не поддерживает Web Push.': 'Цей браузер не підтримує Web Push.',
    'Разрешение есть. Подпишитесь на своём сайте через MailOceanPush.subscribe(), затем отправьте тест на контакт.': 'Дозвіл є. Підпишіться на своєму сайті через MailOceanPush.subscribe(), потім надішліть тест контакту.',
    'Разрешение на уведомления не дано.': 'Дозволу на сповіщення не надано.',
    'Web Push проверен от начала до конца против push-сервиса': 'Web Push перевірено наскрізно з push-сервісом',
    'Сайты: {origins} · ключи созданы {ago}': 'Сайти: {origins} · ключі створено {ago}',
    'Подключите SDK': 'Підключіть SDK',
    'на каждой странице (с проверкой целостности SRI):': 'на кожній сторінці (з перевіркою цілісності SRI):',
    'Положите service worker': 'Покладіть service worker',
    'в корень сайта как': 'у корінь сайту як',
    'Скачать mailocean-sw.js': 'Завантажити mailocean-sw.js',
    'Подпишите посетителя по нажатию': 'Підпишіть відвідувача натисканням',
    '(браузеры требуют действие пользователя):': '(браузери вимагають дії користувача):',
    'одноразовый токен с вашего сервера': 'одноразовий токен з вашого сервера',
    'так подписка привязывается к контакту.': 'так підписка прив’язується до контакту.',
    'Публичный ключ VAPID и SRI': 'Публічний ключ VAPID і SRI',
    'Origin сайта': 'Origin сайту',
    'Сохранить адреса': 'Зберегти адреси',
    'Проверить этот браузер': 'Перевірити цей браузер',
    'Кабинет открыт с одного из адресов сайта.': 'Кабінет відкрито з однієї з адрес сайту.',
    'Неизвестный исход': 'Невідомий результат',
    '— поставщик мог принять сообщение (таймаут после отправки, обрыв, двусмысленный ответ). MailOcean такие шаги': '— провайдер міг прийняти повідомлення (таймаут після надсилання, обрив, неоднозначна відповідь). MailOcean такі кроки',
    'никогда не повторяет': 'ніколи не повторює',
    'и дальше по каскаду не идёт (кроме кодов подтверждения — там следующий канал получает тот же код). Сверку по доказательствам поставщика делает поддержка MailOcean.': 'і каскад далі не йде (окрім кодів підтвердження — там наступний канал отримує той самий код). Звірку за доказами провайдера виконує підтримка MailOcean.',
    'принят': 'прийнято',
    'доставлен': 'доставлено',
    'прочитан': 'прочитано',
    'отказ': 'відмова',
    'пропуск': 'пропущено',
    'неизвестно': 'невідомо',
    'отменён': 'скасовано',
    'все': 'усі',
    'Неизвестных исходов нет': 'Невідомих результатів немає',
    'Шагов пока нет': 'Кроків поки немає',
    'Когда': 'Коли',
    'Адрес': 'Адреса',
    'Состояние': 'Стан',
    'Стоимость': 'Вартість',
    'шаг параллельный': 'паралельний крок',
    'шаг {n}': 'крок {n}',
    'оценка': 'оцінка',
    'Показать ещё': 'Показати ще',
    'Одно уведомление — каскад по каналам: push, Telegram, SMS, WhatsApp, письмо. Дальше по каскаду идём только при точном отказе или по дедлайну — неизвестный исход не дублируем.': 'Одне сповіщення — каскад за каналами: push, Telegram, SMS, WhatsApp, лист. Далі каскад іде лише за точної відмови або за дедлайном — невідомий результат не дублюємо.',
    'Шагов с неизвестным исходом: {n}.': 'Кроків з невідомим результатом: {n}.',
    'Поставщик мог их принять, поэтому MailOcean их не повторяет и дальше по каскаду не идёт; сверку делает поддержка MailOcean.': 'Провайдер міг їх прийняти, тому MailOcean їх не повторює і каскад далі не йде; звірку виконує підтримка MailOcean.',
    'Смотреть остановленные': 'Переглянути зупинені',
    'ваши домены': 'ваші домени',
    ' · аккаунтов: {n}': ' · акаунтів: {n}',
    'платформенный SMS ещё не включён MailOcean': 'платформенний SMS ще не увімкнено MailOcean',
    'аккаунта нет': 'акаунта немає',
    'подключён': 'підключено',
    'отключён вами': 'вимкнено вами',
    'пауза MailOcean': 'пауза MailOcean',
    'адресов: {n}': 'адрес: {n}',
    'за 7 дней · отказов {failed} · неизвестных {unknown} · пропусков {skipped}': 'за 7 днів · відмов {failed} · невідомих {unknown} · пропусків {skipped}',
    'Настроить': 'Налаштувати',
    'Подключить': 'Підключити',
    'Честные сигналы': 'Чесні сигнали',
    'поставщик взял сообщение — ещё не доставка': 'провайдер прийняв повідомлення — це ще не доставка',
    'Доставлено': 'Доставлено',
    'только по отчёту оператора (SMS, WhatsApp) или квитанции нашего SDK (Web Push, push с квитанциями)': 'лише за звітом оператора (SMS, WhatsApp) або квитанцією нашого SDK (Web Push, push із квитанціями)',
    'статус read (WhatsApp, Gateway) или нажатие по уведомлению': 'статус read (WhatsApp, Gateway) або натискання на сповіщення',
    'ваш сервер сообщил: код введён, заказ открыт': 'ваш сервер повідомив: код введено, замовлення відкрито',
    'Telegram-бот сообщает только «принято»: доставку и прочтение Bot API не отдаёт. Push без квитанций приложения — тоже только «принято».': 'Telegram-бот повідомляє лише «прийнято»: Bot API не віддає доставку та прочитання. Push без квитанцій застосунку — теж лише «прийнято».',
    'Разделы каналов': 'Розділи каналів',
    'без страны': 'без країни',
    'Расходы на каналы': 'Витрати на канали',
    'Стоимость по данным поставщика; пока отчёта нет — оценка. Платные шаги вашим аккаунтом поставщика (свой Twilio, WhatsApp, Gateway) MailOcean не выставляет в счёт.': 'Вартість за даними провайдера; до звіту — оцінка. Платні кроки через ваш акаунт провайдера (власні Twilio, WhatsApp, Gateway) MailOcean не виставляє в рахунок.',
    'За {n} дней': 'За {n} днів',
    'все платные шаги': 'усі платні кроки',
    'Оплачено MailOcean': 'Оплачено MailOcean',
    'попадёт в счёт': 'піде у рахунок',
    'Вашим аккаунтом': 'Ваш акаунт',
    'оценка, платите поставщику': 'оцінка, сплачується провайдеру',
    'Сегодня из лимита': 'Сьогодні від ліміту',
    'Израсходовано {n} % дневного лимита': 'Витрачено {n} % денного ліміту',
    'лимит задаёт MailOcean': 'ліміт встановлює MailOcean',
    ' (ваш личный)': ' (ваш особистий)',
    'По дням': 'За днями',
    'По каналам': 'За каналами',
    'По странам': 'За країнами',
    'Период': 'Період',
    '7 дней': '7 днів',
    '14 дней': '14 днів',
    '30 дней': '30 днів',
    '90 дней': '90 днів',
    'оплачено MailOcean': 'оплачено MailOcean',
    'вашим аккаунтом (оценка)': 'вашим акаунтом (оцінка)',
    'За период платных шагов не было.': 'За цей період платних кроків не було.',
    '{label}: принято {accepted}, доставлено {delivered}, единиц {units}': '{label}: прийнято {accepted}, доставлено {delivered}, одиниць {units}',
    'День': 'День',
    'Принято': 'Прийнято',
    'Единиц': 'Одиниць',
    'В счёт MailOcean': 'У рахунок MailOcean',
    'Сохранено': 'Збережено',
    'Аттестация записана': 'Атестацію записано',
    'Настройки каналов': 'Налаштування каналів',
    'Правила пространства: где можно отправлять, когда молчать, какие каналы выключены.': 'Правила простору: куди можна надсилати, коли мовчати, які канали вимкнено.',
    'MailOcean приостановил каналы:': 'MailOcean призупинив канали:',
    'Сообщения этих каналов ждут в очереди.': 'Повідомлення цих каналів чекають у черзі.',
    'Разрешённые страны': 'Дозволені країни',
    'Номера других стран пропускаются (причина «страна не разрешена»). Сейчас доступны только ЕС и ЕЭЗ.': 'Номери інших країн пропускаються (причина «країна не дозволена»). Наразі доступні лише ЄС і ЄЕЗ.',
    'Страны на паузе из-за подозрения на накрутку SMS (pumping):': 'Країни на паузі через підозру на накрутку SMS (pumping):',
    'Снять паузу может поддержка MailOcean.': 'Зняти паузу може підтримка MailOcean.',
    'Канал включён': 'Канал увімкнено',
    'Канал выключен: его шаги будут ждать': 'Канал вимкнено: його кроки чекатимуть',
    'выключен': 'вимкнено',
    'Выключенный канал — удержание: строки ждут в очереди и уйдут после включения (кроме тех, чей шаг каскада закроет дедлайн).': 'Вимкнений канал утримує рядки: вони чекають у черзі й підуть після увімкнення (крім тих, чий крок каскаду закриє дедлайн).',
    'Тихие часы маркетинга': 'Тихі години маркетингу',
    'По поясу контакта. Сервисные сообщения и коды идут всегда. По умолчанию {start}–{end}.': 'За часовим поясом контакту. Сервісні повідомлення і коди надсилаються завжди. За замовчуванням {start}–{end}.',
    'Начало': 'Початок',
    'Конец': 'Кінець',
    'Сохранить': 'Зберегти',
    'Возвращены часы по умолчанию': 'Повернуто години за замовчуванням',
    'По умолчанию': 'За замовчуванням',
    'Аттестации': 'Атестації',
    'Подтверждает только владелец пространства; текст и версия пишутся в журнал.': 'Підтверджує лише власник простору; текст і версія записуються в журнал.',
    'Дневной лимит расходов': 'Денний ліміт витрат',
    'в сутки · сегодня': 'на добу · сьогодні',
    'Когда лимит исчерпан, платные шаги пропускаются (причина «дневной лимит»), бесплатные каналы работают. Изменить лимит может MailOcean — напишите в поддержку.': 'Коли ліміт вичерпано, платні кроки пропускаються (причина «денний ліміт»); безкоштовні канали працюють. Змінити ліміт може лише MailOcean — напишіть у підтримку.',
    'код {n} цифр, {ttl}': 'код {n} цифр, {ttl}',
    ' · неизвестный исход → следующий канал': ' · невідомий результат → наступний канал',
    'цель «{event}»': 'мета «{event}»',
    'успех: {result} · дедлайн → {next}': 'успіх: {result} · дедлайн → {next}',
    'дальше': 'далі',
    'стоп': 'стоп',
    'Политики каскада': 'Політики каскаду',
    'Порядок каналов, дедлайны, что считать успехом и что делать с неизвестным исходом. Версии неизменяемы: та же политика — та же версия.': 'Порядок каналів, дедлайни, що вважати успіхом і що робити з невідомим результатом. Версії незмінні: та сама політика — та сама версія.',
    'ключ_политики': 'ключ_політики',
    'Ключ новой политики': 'Ключ нової політики',
    'Новая': 'Нова',
    'Своих политик пока нет': 'Власних політик поки немає',
    'Начните со встроенной — первое использование скопирует её в пространство как версию 1.': 'Почніть із вбудованої — перше використання скопіює її в простір як версію 1.',
    'Политика {key}: {kind}': 'Політика {key}: {kind}',
    'код подтверждения': 'код підтвердження',
    'из встроенной': 'з вбудованої',
    'встроенная': 'вбудована',
    'в архиве': 'в архіві',
    ' · потолок {sum}': ' · стеля {sum}',
    'ещё не использовалась': 'ще не використовувалась',
    'Политика не найдена': 'Політику не знайдено',
    'Проверьте ключ или создайте новую в списке политик.': 'Перевірте ключ або створіть нову в списку політик.',
    'Без изменений: та же политика — та же версия': 'Без змін: та сама політика — та сама версія',
    'Сохранена версия {n}': 'Збережено версію {n}',
    'Убрать «{key}» в архив? Новые уведомления с ней не создаются; уже идущие доживут по своей версии.': 'Перенести «{key}» до архіву? Нові сповіщення з нею не створюватимуться; вже запущені дійдуть за своєю версією.',
    'Политика в архиве': 'Політику в архіві',
    'Все политики': 'Усі політики',
    'встроенная, ещё не использовалась': 'вбудована, ще не використовувалась',
    'новая': 'нова',
    'проверяю…': 'перевіряю…',
    'есть несохранённые изменения': 'є незбережені зміни',
    'Тест': 'Тест',
    'В архив': 'В архів',
    'Сохраняю…': 'Зберігаю…',
    'Сохранить версию': 'Зберегти версію',
    'Редактор': 'Редактор',
    'Как код': 'Як код',
    'Версии · {n}': 'Версії · {n}',
    'Как это работает': 'Як це працює',
    'Шаг ждёт свой дедлайн. Пришёл сигнал успеха — каскад останавливается, ещё не отправленные шаги отменяются.': 'Крок чекає свого дедлайну. Прийшов сигнал успіху — каскад зупиняється, ще не надіслані кроки скасовуються.',
    'Точный отказ (адреса нет, поставщик отказал, человек заблокировал бота) — сразу следующий шаг.': 'Точна відмова (немає адреси, провайдер відмовив, людина заблокувала бота) — одразу наступний крок.',
    'Неизвестный исход (таймаут после отправки) —': 'Невідомий результат (таймаут після надсилання) —',
    ': сообщение могло дойти. Исключение — коды подтверждения: тот же код в следующем канале безопасен.': ': повідомлення могло дійти. Виняток — коди підтвердження: той самий код у наступному каналі безпечний.',
    'Шаг без адреса, согласия или цены пропускается с причиной — это видно в «Погружении уведомления».': 'Крок без адреси, згоди або ціни пропускається з причиною — це видно в «Зануренні сповіщення».',
    'Определение политики (JSON)': 'Визначення політики (JSON)',
    'JSON не разбирается — изменение не применено': 'JSON не розбирається — зміну не застосовано',
    'Проверено сервером на лету. Нормализованный вид (с умолчаниями) — во вкладке «Версии».': 'Перевіряється сервером на льоту. Нормалізований вигляд (із значеннями за замовчуванням) — на вкладці «Версії».',
    'Политика как код: тот же PUT с тем же определением даёт ту же версию — его безопасно выполнять при каждом деплое.': 'Політика як код: той самий PUT з тим самим визначенням дає ту саму версію — його безпечно виконувати при кожному деплої.',
    'Версий нет': 'Версій немає',
    'Политика ещё не сохранялась.': 'Політику ще не зберігали.',
    'Версия': 'Версія',
    'Источник': 'Джерело',
    'текущая': 'поточна',
    'кабинет': 'кабінет',
    'Скрыть': 'Приховати',
    'Сравнить с v{n}': 'Порівняти з v{n}',
    'Шаблоны каналов': 'Шаблони каналів',
    'Один шаблон — варианты для SMS, Telegram, push, Web Push, WhatsApp и письма. Каскад берёт вариант того канала, на котором стоит шаг; без варианта шаг пропускается.': 'Один шаблон — варіанти для SMS, Telegram, push, Web Push, WhatsApp і листа. Каскад бере варіант того каналу, на якому стоїть крок; без варіанту крок пропускається.',
    'Ключ нового шаблона': 'Ключ нового шаблону',
    'Новый': 'Новий',
    'Шаблонов пока нет': 'Шаблонів поки немає',
    'Создайте первый: например «order_shipped» с вариантами SMS и push.': 'Створіть перший, наприклад «order_shipped» з варіантами SMS і push.',
    'переменные:': 'змінні:',
    'изменён': 'змінено',
    'Заказ {{order_id}} отправлен: {{url}}': 'Замовлення {{order_id}} відправлено: {{url}}',
    'Заказ отправлен': 'Замовлення відправлено',
    'Заказ {{order_id}} уже в пути': 'Замовлення {{order_id}} вже в дорозі',
    'Данные для превью: JSON не разбирается': 'Дані для перегляду: JSON не розбирається',
    'Шаблон не найден': 'Шаблон не знайдено',
    'Без изменений': 'Без змін',
    'Убрать шаблон «{key}» в архив? Новые уведомления с ним не создаются.': 'Перенести шаблон «{key}» до архіву? Нові сповіщення з ним не створюватимуться.',
    'Шаблон в архиве': 'Шаблон в архіві',
    'Все шаблоны': 'Усі шаблони',
    'новый': 'новий',
    'подставляет значение (в Telegram — с экранированием HTML),': 'підставляє значення (у Telegram — з екрануванням HTML),',
    '— сырой HTML, только в Telegram. Отсутствующая переменная — ошибка (422), не пустая строка. Коды подтверждения — встроенный шаблон Verify API, здесь не нужен.': '— сирий HTML, лише в Telegram. Відсутня змінна — помилка (422), а не порожній рядок. Коди підтвердження використовують вбудований шаблон Verify API і тут не потрібні.',
    'Данные для превью (JSON)': 'Дані для перегляду (JSON)',
    'Переменные: {list}': 'Змінні: {list}',
    'Переменных нет': 'Змінних немає',
    'Версии': 'Версії',
    'Уведомление хранит версию шаблона: изменение не трогает уже отправленные. Сценарии закрепляют версию в своём хеше.': 'Сповіщення зберігає версію шаблону: зміна не торкається вже надісланих. Сценарії закріплюють версію у своєму хеші.',
    'тест {name}': 'тест {name}',
    'Убрать вариант {label}': 'Прибрати варіант {label}',
    'Добавить вариант {label}': 'Додати варіант {label}',
    'Текст SMS': 'Текст SMS',
    'Счётчик — по тексту шаблона; после подстановки переменных сегментов может стать больше (цена — за сегмент). Ссылки идут как есть.': 'Лічильник — за текстом шаблону; після підстановки змінних сегментів може стати більше (ціна — за сегмент). Посилання надсилаються як є.',
    'Сообщение (Telegram HTML)': 'Повідомлення (Telegram HTML)',
    'Разрешены <b>, <i>, <u>, <s>, <a href>, <code>, <pre>, <blockquote>': 'Дозволено: <b>, <i>, <u>, <s>, <a href>, <code>, <pre>, <blockquote>',
    'Кнопка со ссылкой': 'Кнопка з посиланням',
    'Открыть': 'Відкрити',
    'Текст кнопки': 'Текст кнопки',
    'Ссылка кнопки': 'Посилання кнопки',
    'Заголовок': 'Заголовок',
    'Текст': 'Текст',
    'Ссылка по нажатию (https)': 'Посилання при натисканні (https)',
    'Иконка (https)': 'Іконка (https)',
    'Не скрывать, пока не нажмут': 'Не ховати, доки не натиснуть',
    'Web Push — до 3 993 байт JSON вместе с подстановками.': 'Web Push — до 3 993 байтів JSON разом із підстановками.',
    'Картинка (https, необязательно)': 'Зображення (https, необов’язково)',
    'WhatsApp (шаблон Meta)': 'WhatsApp (шаблон Meta)',
    'Вне окна 24 ч WhatsApp пропускает только одобренный шаблон Meta. Сопоставьте его параметры': 'Поза вікном 24 год WhatsApp пропускає лише схвалений шаблон Meta. Зіставте його параметри',
    '… с переменными уведомления.': '… зі змінними сповіщення.',
    'Имя шаблона Meta': 'Назва шаблону Meta',
    'Язык': 'Мова',
    'Категория': 'Категорія',
    'Параметр {n}': 'Параметр {n}',
    'Убрать параметр {n}': 'Прибрати параметр {n}',
    'Параметр': 'Параметр',
    'Сообщение в открытом окне 24 ч (необязательно)': 'Повідомлення у відкритому вікні 24 год (необов’язково)',
    'Свободный текст — только если человек сам написал вам за последние 24 часа': 'Вільний текст — лише якщо людина сама написала вам за останні 24 години',
    'Отправитель': 'Відправник',
    'Адрес на подтверждённом домене': 'Адреса на підтвердженому домені',
    'Тема': 'Тема',
    'Текст письма': 'Текст листа',
    'Email-шаг создаёт обычное письмо: его путь виден в «Письма», ссылка — в погружении уведомления.': 'Крок email створює звичайний лист: його шлях видно в «Листи», посилання — у занурені сповіщення.',
    'шаблон': 'шаблон',
    'Подключено и проверено': 'Підключено і перевірено',
    'Сохранено, но проверка не прошла: {error}': 'Збережено, але перевірка не пройшла: {error}',
    'ошибка поставщика': 'помилка провайдера',
    'Название (для вас)': 'Назва (для вас)',
    'Файл больше 20 КБ — это не похоже на ключ': 'Файл більший за 20 КБ — це не схоже на ключ',
    'файл прочитан ({n} символов) — уйдёт на сервер запечатанным': 'файл прочитано ({n} символів) — надійде на сервер запечатаним',
    'Проверяю…': 'Перевіряю…',
    'Подключить и проверить': 'Підключити і перевірити',
    'Заполните: {fields}': 'Заповніть: {fields}',
    'Секреты хранятся запечатанными и обратно не показываются — только «секрет сохранён». Проверка ничего не отправляет людям.': 'Секрети зберігаються запечатаними і більше не показуються — лише «секрет збережено». Перевірка нікому нічого не надсилає.',
    'Аккаунтов нет.': 'Акаунтів немає.',
    'Проверка прошла': 'Перевірку пройдено',
    'Проверка не прошла: {error}': 'Перевірку не пройдено: {error}',
    'Отключить «{name}»? Шаги через этот аккаунт будут пропускаться (channel_not_configured).': 'Вимкнути «{name}»? Кроки через цей акаунт пропускатимуться (channel_not_configured).',
    'аккаунт MailOcean': 'акаунт MailOcean',
    'Проверить': 'Перевірити',
    'Адрес вебхука': 'Адреса вебхука',
    'Отключить {name}': 'Вимкнути {name}',
    'Бот:': 'Бот:',
    'секрет сохранён · обновлён {time}': 'секрет збережено · оновлено {time}',
    'Последняя проверка: {error}': 'Остання перевірка: {error}',
    'Адрес вебхука бота (MailOcean ставит его сам через setWebhook; показан для диагностики)': 'Адреса вебхука бота (MailOcean встановлює її сам через setWebhook; показано для діагностики)',
    'Адрес вебхука для консоли поставщика': 'Адреса вебхука для консолі провайдера',
    ' · режим {mode}': ' · режим {mode}',
    'Verify token (показывается один раз):': 'Verify token (показується один раз):',
    'активен': 'активний',
    'недействителен': 'недійсний',
    'отозван': 'відкликано',
    'кодом': 'кодом',
    'кнопкой Start': 'кнопкою Start',
    'импортом': 'імпортом',
    'по API': 'через API',
    'отправлено': 'надіслано',
    'Передано поставщику': 'Передано провайдеру',
    'принято': 'прийнято',
    'доставлено': 'доставлено',
    'прочитано': 'прочитано',
    'в очереди': 'у черзі',
    'передан': 'передано',
    'Telegram-бот': 'Telegram-бот',
    'Мобильный push': 'Мобільний push',
    'Письма через ваш домен — как в разделе «Письма».': 'Листи з вашого домену — як у розділі «Листи».',
    'Платформенный SMS MailOcean: подключать ничего не нужно, оплата в счёте.': 'Платформенні SMS MailOcean: нічого підключати не потрібно, оплата у рахунку.',
    'Ваш WhatsApp Business (WABA): шаблоны Meta, окно 24 ч. Meta выставляет счёт вам напрямую.': 'Ваш WhatsApp Business (WABA): шаблони Meta, вікно 24 год. Meta виставляє рахунок вам напряму.',
    'Ваш бот: человек сам привязывает чат ссылкой. Бесплатно, но бот не сообщает «доставлено».': 'Ваш бот: людина сама прив’язує чат за посиланням. Безкоштовно, але бот не повідомляє «доставлено».',
    'Коды подтверждения в Telegram по номеру телефона. Оплачивается вашим аккаунтом Telegram.': 'Коди підтвердження в Telegram за номером телефону. Оплачується вашим акаунтом Telegram.',
    'Ваше мобильное приложение через FCM и APNs. Доставку видно только по квитанциям приложения.': 'Ваш мобільний застосунок через FCM і APNs. Доставку видно лише за квитанціями застосунку.',
    'Уведомления в браузере на вашем сайте. Ключи VAPID MailOcean создаёт сам, бесплатно.': 'Сповіщення у браузері на вашому сайті. Ключі VAPID MailOcean створює сам, безкоштовно.',
    'Поставщик принял сообщение. Это ещё не значит, что оно дошло.': 'Провайдер прийняв повідомлення. Це ще не означає, що воно дійшло.',
    'Доставлено по отчёту оператора или по квитанции нашего SDK.': 'Доставлено за звітом оператора або за квитанцією нашого SDK.',
    'Открыто или нажато по событию канала (квитанция, статус read).': 'Відкрито або натиснуто за подією каналу (квитанція, статус read).',
    'Тестовый поставщик': 'Тестовий постачальник',
    'в плане': 'заплановано',
    'пропущен': 'пропущено',
    'ждёт тихих часов': 'чекає тихих годин',
    'принят каналом': 'прийнято каналом',
    'неизвестный исход': 'невідомий результат',
    'у получателя нет адреса в этом канале': 'у одержувача немає адреси в цьому каналі',
    'адрес недоступен: отозван, недействителен или не подходит каналу (например, стационарный номер для SMS)': 'адреса недоступна: відкликана, недійсна або не підходить для каналу (наприклад, стаціонарний номер для SMS)',
    'канал не подключён или аккаунт не проверен': 'канал не підключено або акаунт не перевірено',
    'канал на паузе': 'канал на паузі',
    'нет согласия на этот канал и цель': 'немає згоди на цей канал і мету',
    'адрес в подавлениях канала': 'адреса в списку придушення каналу',
    'тихие часы получателя': 'тихі години одержувача',
    'страна номера не разрешена в настройках': 'країну номера не дозволено в налаштуваннях',
    'частотный лимит контакта': 'частотний ліміт контакту',
    'шаг дороже потолка цены уведомления': 'крок дорожчий за стелю ціни сповіщення',
    'исчерпан дневной лимит расходов': 'денний ліміт витрат вичерпано',
    'в шаблоне нет варианта для этого канала': 'у шаблоні немає варіанта для цього каналу',
    'окно WhatsApp 24 ч закрыто, а шаблона Meta нет': 'вікно WhatsApp 24 год закрито, а шаблону Meta немає',
    'Идёт': 'Триває',
    'Каскад ещё работает: ждём сигнала или дедлайна шага': 'Каскад ще працює: чекаємо на сигнал або дедлайн кроку',
    'Цель достигнута': 'Мету досягнуто',
    'Достигнут сигнал успеха политики': 'Досягнуто сигналу успіху політики',
    'Не отправлено': 'Не надіслано',
    'Каждый шаг пропущен или получил точный отказ': 'Кожен крок пропущено або отримано точну відмову',
    'Остановлено': 'Зупинено',
    'Отправлено, подтверждения нет — дальше не шлём, чтобы не продублировать': 'Надіслано, але підтвердження немає — далі не надсилаємо, щоб не дублювати',
    'Отменено': 'Скасовано',
    'Отменено до передачи; переданные шаги не отзываются': 'Скасовано до передачі; передані кроки не відкликаються',
    'Срок кода истёк': 'Термін коду минув',
    'Код не ввели вовремя': 'Код не ввели вчасно',
    'Неизвестный исход шага: сообщение могло дойти, поэтому дальше не шлём, чтобы не продублировать.': 'Невідомий результат кроку: повідомлення могло дійти, тому далі не надсилаємо, щоб не дублювати.',
    'Дедлайн шага прошёл без сигнала, а политика велит остановиться (on_timeout: stop).': 'Дедлайн кроку минув без сигналу, а політика наказує зупинитися (on_timeout: stop).',
    'Шаги закончились: хотя бы один принят каналом, но подтверждения успеха нет.': 'Кроки закінчилися: принаймні один прийнято каналом, але підтвердження успіху немає.',
    'Уведомление создано': 'Сповіщення створено',
    'Шаг запланирован': 'Крок заплановано',
    'Шаг пропущен': 'Крок пропущено',
    'Ждёт тихих часов': 'Чекає тихих годин',
    'Поставлен в очередь': 'Поставлено в чергу',
    'Удержан': 'Утримано',
    'Передан поставщику': 'Передано провайдеру',
    'Повтор (поставщик точно не принял)': 'Повтор (провайдер точно не прийняв)',
    'Нажато': 'Натиснуто',
    'Отказ': 'Відскок',
    'Заменён другим маршрутом': 'Замінено іншим маршрутом',
    'Деньги возвращены': 'Гроші повернено',
    'Цена от поставщика': 'Ціна від провайдера',
    'Дедлайн шага': 'Дедлайн кроку',
    'Переход к следующему шагу': 'Перехід до наступного кроку',
    'Сигнал от вашего сервера': 'Сигнал з вашого сервера',
    'Введён неверный код': 'Введено неправильний код',
    'Код подтверждён': 'Код підтверджено',
    'Успех политики': 'Успіх політики',
    'Уведомление завершено': 'Сповіщення завершено',
    'Сверено сотрудником MailOcean': 'Звірено працівником MailOcean',
    'Письмо в очереди': 'Лист у черзі',
    'Письмо передано провайдеру': 'Лист передано провайдеру',
    'Письмо принято провайдером': 'Лист прийнято провайдером',
    'Письмо доставлено': 'Лист доставлено',
    'Письмо отскочило': 'Лист відскочив',
    'Исход письма неизвестен': 'Результат листа невідомий',
    'Письмо отменено': 'Лист скасовано',
    'Письмо не отправлено': 'Лист не надіслано',
    'Чат Telegram': 'Чат Telegram',
    'Устройство Android/FCM': 'Пристрій Android/FCM',
    'Устройство iOS/APNs': 'Пристрій iOS/APNs',
    'Подписка Web Push': 'Підписка Web Push',
    'согласие': 'згода',
    'отзыв': 'відкликання',
    'нет записи': 'немає запису',
    'ответил STOP': 'відповів STOP',
    'заблокировал': 'заблокував',
    'адрес недействителен': 'адреса недійсна',
    'жалоба': 'скарга',
    'вручную': 'вручну',
    'Австрия': 'Австрія',
    'Бельгия': 'Бельгія',
    'Болгария': 'Болгарія',
    'Хорватия': 'Хорватія',
    'Кипр': 'Кіпр',
    'Чехия': 'Чехія',
    'Дания': 'Данія',
    'Эстония': 'Естонія',
    'Финляндия': 'Фінляндія',
    'Франция': 'Франція',
    'Германия': 'Німеччина',
    'Греция': 'Греція',
    'Венгрия': 'Угорщина',
    'Ирландия': 'Ірландія',
    'Италия': 'Італія',
    'Латвия': 'Латвія',
    'Литва': 'Литва',
    'Люксембург': 'Люксембург',
    'Мальта': 'Мальта',
    'Нидерланды': 'Нідерланди',
    'Польша': 'Польща',
    'Португалия': 'Португалія',
    'Румыния': 'Румунія',
    'Словакия': 'Словаччина',
    'Словения': 'Словенія',
    'Испания': 'Іспанія',
    'Швеция': 'Швеція',
    'Исландия': 'Ісландія',
    'Лихтенштейн': 'Ліхтенштейн',
    'Норвегия': 'Норвегія',
    'Уведомления': 'Сповіщення',
    'Шаблоны': 'Шаблони',
    'Расходы': 'Витрати',
    'Настройки': 'Налаштування',
    'Регион': 'Регіон',
    'Ireland (IE1) — данные в ЕС': 'Ірландія (IE1) — дані в ЄС',
    'Имя отправителя (Alphanumeric Sender ID)': 'Ім’я відправника (alphanumeric Sender ID)',
    'До 11 латинских букв и цифр; или Messaging Service SID ниже': 'До 11 латинських літер і цифр; або Messaging Service SID нижче',
    'Messaging Service SID (необязательно)': 'Messaging Service SID (необов’язково)',
    'API Key SID региона': 'API Key SID регіону',
    'Auth Token региона': 'Auth Token регіону',
    'Им Twilio подписывает отчёты о доставке — без него статусы не принимаются': 'Twilio підписує звіти про доставку ним — без нього статуси не приймаються',
    'Имя отправителя': 'Ім’я відправника',
    'Постоянный токен системного пользователя': 'Постійний токен системного користувача',
    'Права whatsapp_business_messaging и whatsapp_business_management, срок «Never»': 'Права whatsapp_business_messaging і whatsapp_business_management, строк «Never»',
    'Им Meta подписывает вебхуки (X-Hub-Signature-256)': 'Meta підписує вебхуки ним (X-Hub-Signature-256)',
    'Токен бота от @BotFather': 'Токен бота від @BotFather',
    'Ответ на /start': 'Відповідь на /start',
    'Готово! Теперь уведомления о заказах придут сюда.': 'Готово! Тепер сповіщення про замовлення надходитимуть сюди.',
    'API-токен Telegram Gateway': 'API-токен Telegram Gateway',
    'Ключ сервисного аккаунта (JSON)': 'Ключ сервісного облікового запису (JSON)',
    'Приложение шлёт квитанции (доставлено/нажато)': 'Застосунок надсилає квитанції (доставлено/натиснуто)',
    'Без квитанций push сообщает только «принято»': 'Без квитанцій push повідомляє лише «прийнято»',
    'Ключ APNs (.p8)': 'Ключ APNs (.p8)',
    'Скачивается один раз в Certificates, IDs & Profiles → Keys. Обратно не показывается': 'Завантажується один раз у Certificates, IDs & Profiles → Keys. Більше не показується',
    'Bundle ID приложения': 'Bundle ID застосунку',
    'Среда': 'Середовище',
    'sandbox (dev-сборки)': 'sandbox (dev-збірки)',
    'работает': 'працює',
    'сбоит': 'збоїть',
    'отключён': 'вимкнено',
  },
};
